import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import DashboardService from "../services/dashboardService";
import DailyReportService from "../services/DailyReportService";
import StorageService from "../services/StorageService";
import Breadcrumb from "../components/Breadcrumb";
import ProjectService from "../services/ProjectService";
import ProjectLocationService from "../services/ProjectLocationService";
import ProjectCategoryService from "../services/ProjectCategoryService";
import "./../Dashboard.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';

export default function Dashboard() {
  const [dashboardData, setDashboardData] = useState({
    fuelExpenseToday: 0,
    totalPettyCashBalance: 0,
    todaysPettyCashUsed: 0,
    ongoingProjects: 0,
    totalProjects: 0,
    todaysDPR: [],
    upcomingInsurance: 0,
    upcomingTax: 0,
    upcomingTotal: 0,
    totalVehicles: 0,
    availableVehicles: 0,
    assignedVehicles: 0,
    vehicleTransferSummary: {},
    recentTransfers: []
  });
  const user = StorageService.loginData() || {};
  const isSuperOrPm =
    user.roleName === "Super Admin" ||
    user.roleName === "SuperAdmin" ||
    user.roleName === "Data Admin" ||
    user.roleName === "DataAdmin" ||
    user.roleName === "Admin" ||
    user.roleName === "admin" ||
    user.roleName === "Project Manager" ||
    Number(user.roleId) === 1 ||
    Number(user.roleId) === 2 ||
    Number(user.roleId) === 6;

  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [projectCategories, setProjectCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [isProjectsLoaded, setIsProjectsLoaded] = useState(false);
  const [sbLocationFilter, setSbLocationFilter] = useState("");
  const [sbCategoryFilter, setSbCategoryFilter] = useState("");
  const [sbItemFilter, setSbItemFilter] = useState("");

  const [locationSearch, setLocationSearch] = useState("");
  const [categorySearch, setCategorySearch] = useState("");
  const [itemSearch, setItemSearch] = useState("");

  const [showLocationDropdown, setShowLocationDropdown] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showItemDropdown, setShowItemDropdown] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const company = StorageService.activeCompany();

  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");

  const getYesterdayDateString = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const [selectedDate, setSelectedDate] = useState(getYesterdayDateString());

  const [duesModal, setDuesModal] = useState({
    isOpen: false,
    type: "",
    list: []
  });

  const handleShowDuesModal = (type, list) => {
    setDuesModal({
      isOpen: true,
      type,
      list: list || []
    });
  };

  const handleCloseDuesModal = () => {
    setDuesModal({
      isOpen: false,
      type: "",
      list: []
    });
  };

  const [dprDetailsModal, setDprDetailsModal] = useState({
    isOpen: false,
    data: null,
    activeTab: "work",
    loading: false
  });

  const [vehicleDetailsModal, setVehicleDetailsModal] = useState({
    isOpen: false,
    vehicleType: "",
    statusType: "",
    list: []
  });

  const handleShowVehicleDetails = (vehicleType, statusType, list) => {
    if (!list || list.length === 0) return;
    setVehicleDetailsModal({
      isOpen: true,
      vehicleType,
      statusType,
      list
    });
  };

  const handleShowDPRModal = async (item) => {
    setDprDetailsModal({
      isOpen: true,
      data: null,
      activeTab: "work",
      loading: true
    });
    try {
      const res = await DailyReportService.getReport(item.id);
      if (res && res.status) {
        setDprDetailsModal(prev => ({
          ...prev,
          data: res.data,
          loading: false
        }));
      } else {
        setDprDetailsModal(prev => ({
          ...prev,
          loading: false
        }));
      }
    } catch (err) {
      console.error("Error fetching DPR details:", err);
      setDprDetailsModal(prev => ({
        ...prev,
        loading: false
      }));
    }
  };

  const handleCloseDPRModal = () => {
    setDprDetailsModal({
      isOpen: false,
      data: null,
      activeTab: "work",
      loading: false
    });
  };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length !== 3) return dateStr;
    const dateObj = new Date(parts[0], parts[1] - 1, parts[2]);
    return dateObj.toLocaleDateString("en-GB", { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-');
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const cleanDate = dateStr.substring(0, 10);
    const parts = cleanDate.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`;
    }
    return cleanDate;
  };

  const formatDateTime = (dateTimeStr) => {
    if (!dateTimeStr) return "";
    try {
      const date = new Date(dateTimeStr);
      if (isNaN(date.getTime())) return dateTimeStr;

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      let hours = date.getHours();
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      const strHours = String(hours).padStart(2, '0');

      return `${day}-${month}-${year} ${strHours}:${minutes} ${ampm}`;
    } catch (e) {
      return dateTimeStr;
    }
  };

  const loadProjects = async () => {
    const emp = StorageService.loginData();
    const comp = StorageService.activeCompany();

    try {
      let projectsData = [];

      // ✅ ADMIN & DATA ADMIN & PROJECT MANAGER → ALL PROJECTS
      if (
        emp.roleName === "Super Admin" ||
        emp.roleName === "SuperAdmin" ||
        emp.roleName === "Data Admin" ||
        emp.roleName === "DataAdmin" ||
        emp.roleName === "Admin" ||
        emp.roleName === "admin" ||
        emp.roleName === "Project Manager" ||
        Number(emp.roleId) === 1 ||
        Number(emp.roleId) === 2 ||
        Number(emp.roleId) === 6
      ) {
        const res = await ProjectService.getActive(comp.companyId);

        projectsData = (res || []).map(p => ({
          projectId: p.id,
          projectName: p.projectName,
          projectCode: p.projectCode,
          projectCategoryId: p.projectCategoryId,
          projectCategoryName: p.projectCategoryName
        }));
      }
      // ✅ EMPLOYEE → ONLY ASSIGNED PROJECTS
      else {
        const res = await ProjectService.getAssignedProjects(
          comp.companyId,
          emp.employeeId
        );

        projectsData = (res?.data?.data || []).map(p => ({
          projectId: p.projectId,
          projectName: p.projectName,
          projectCode: p.projectCode,
          projectCategoryId: p.projectCategoryId,
          projectCategoryName: p.projectCategoryName
        }));
      }

      setProjects(projectsData);

      // Auto select the first project and its category on initial dashboard load to reduce unnecessary data calling
      if (projectsData.length > 0) {
        const defaultProj = projectsData[0];
        setSelectedProject(defaultProj.projectId);
        setSearchText(`${defaultProj.projectName} - ${defaultProj.projectCode}`);
        if (defaultProj.projectCategoryId) {
          setSelectedCategory(defaultProj.projectCategoryId);
        }
      }
    } catch (err) {
      console.error("Error loading projects:", err);
      setProjects([]);
    } finally {
      setIsProjectsLoaded(true);
    }
  };

  const loadCategories = async () => {
    try {
      const res = await ProjectCategoryService.getActive();
      const categoriesData = res?.data || res || [];
      setProjectCategories(categoriesData);
    } catch (err) {
      console.error("Error loading categories:", err);
      setProjectCategories([]);
    }
  };

  useEffect(() => {
    const fetchDashboardSummary = async () => {
      try {
        if (!company?.companyId || !isProjectsLoaded) return;
        setLoading(true);

        const res = await DashboardService.getDashboardSummary({
          companyId: company.companyId,
          employeeId: user.employeeId,
          roleId: user.roleId,
          projectId: selectedProject ? Number(selectedProject) : null,
          projectCategoryId: selectedCategory ? Number(selectedCategory) : null,
          date: selectedDate,
        });

        if (res.status) {
          setDashboardData(prev => ({
            ...prev,
            ...res.data,
            todaysDPR: res.data.todaysDPR || [],
          }));
        }
        setLoading(false);
      } catch (error) {
        console.error("Dashboard API Error:", error);
        setLoading(false);
      }
    };

    fetchDashboardSummary();
  }, [company?.companyId, user?.employeeId, user?.roleId, selectedProject, selectedCategory, selectedDate, isProjectsLoaded]);

  useEffect(() => {
    if (company?.companyId && user?.employeeId) {
      loadProjects();
      loadCategories();
    }
  }, [company?.companyId, user?.employeeId]);

  useEffect(() => {
    let catFirstLetter = "";
    let projName = "";

    if (selectedCategory) {
      const cat = projectCategories.find(c => Number(c.id) === Number(selectedCategory));
      if (cat?.categoryName) {
        catFirstLetter = cat.categoryName.trim().charAt(0).toUpperCase();
      }
    }

    if (selectedProject) {
      const proj = projects.find(p => Number(p.projectId) === Number(selectedProject));
      if (proj) {
        if (!catFirstLetter) {
          if (proj.projectCategoryName) {
            catFirstLetter = proj.projectCategoryName.trim().charAt(0).toUpperCase();
          } else if (proj.projectCategoryId) {
            const cat = projectCategories.find(c => Number(c.id) === Number(proj.projectCategoryId));
            if (cat?.categoryName) {
              catFirstLetter = cat.categoryName.trim().charAt(0).toUpperCase();
            }
          }
        }
        projName = proj.projectName;
      }
    }

    let title = "";
    if (catFirstLetter && projName) {
      title = `${catFirstLetter} * ${projName}`;
    } else if (projName) {
      title = projName;
    } else if (catFirstLetter) {
      title = `${catFirstLetter} * All Projects`;
    }

    window.dispatchEvent(new CustomEvent("dashboardHeaderTitleUpdate", { detail: title }));
    sessionStorage.setItem("dashboardHeaderTitle", title);

    return () => {
      window.dispatchEvent(new CustomEvent("dashboardHeaderTitleUpdate", { detail: "" }));
      sessionStorage.removeItem("dashboardHeaderTitle");
    };
  }, [selectedCategory, selectedProject, projectCategories, projects]);

  useEffect(() => {
    const handleClickOutside = () => {
      setShowDropdown(false);
      setShowLocationDropdown(false);
      setShowCategoryDropdown(false);
      setShowItemDropdown(false);
    };
    window.addEventListener("click", handleClickOutside);
    return () => window.removeEventListener("click", handleClickOutside);
  }, []);

  const [projectLocations, setProjectLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");

  useEffect(() => {
    const fetchLocations = async () => {
      try {
        if (selectedProject) {
          const res = await ProjectLocationService.getByProjectId(selectedProject);
          if (res && res.status) {
            setProjectLocations(res.data || []);
          } else {
            setProjectLocations([]);
          }
        } else {
          const res = await ProjectLocationService.getAll(1, 1000);
          if (res && res.status && res.data) {
            setProjectLocations(res.data.data || []);
          } else {
            setProjectLocations([]);
          }
        }
      } catch (err) {
        console.error("Error loading project locations:", err);
        setProjectLocations([]);
      }
      setSelectedLocation(""); // Reset location selection when project changes
    };

    fetchLocations();
  }, [selectedProject, company?.companyId, user?.employeeId]);

  useEffect(() => {
    setSbLocationFilter("");
    setSbCategoryFilter("");
    setSbItemFilter("");
    setLocationSearch("");
    setCategorySearch("");
    setItemSearch("");
  }, [selectedProject]);

  const getStatusClass = (status) => {
    switch (status) {
      case "Pending": return "bg-info";
      case "Approved": return "bg-success";
      case "Rejected": return "bg-danger";
      case "Transfered": return "bg-primary";
      case "Released": return "bg-warning";
      case "Received": return "bg-dark";
      default: return "bg-secondary";
    }
  };

  const groupedDPR = (dashboardData.todaysDPR || []).reduce((acc, item) => {
    if (!acc[item.projectName]) {
      acc[item.projectName] = [];
    }
    acc[item.projectName].push(item);
    return acc;
  }, {});

  const pendingStockIn = dashboardData.extraSection?.pendingDetails?.stockIn || [];
  const pendingStockOut = dashboardData.extraSection?.pendingDetails?.stockOut || [];
  const pendingStockTransfer = dashboardData.extraSection?.pendingDetails?.stockTransfer || [];
  const pendingStockReturn = dashboardData.extraSection?.pendingDetails?.stockReturn || [];
  const pendingReceiveStockReturn = dashboardData.extraSection?.pendingDetails?.receiveStockReturn || [];
  const pendingStockSales = dashboardData.extraSection?.pendingDetails?.stockSales || [];
  const pendingDPR = dashboardData.extraSection?.pendingDetails?.dpr || [];
  const pendingVehicleReading = dashboardData.extraSection?.pendingDetails?.vehicleReading || [];
  const pendingDPRStockOut = dashboardData.extraSection?.pendingDetails?.dprStockOut || [];


  const rawDprList = dashboardData.dailyProgressSection?.dpr || [];
  const rawDprMaterials = dashboardData.dailyProgressSection?.dprMaterials || [];
  const rawDprLabourDetails = dashboardData.dailyProgressSection?.dprLabourDetails || [];
  const rawDprStatuses = dashboardData.dailyProgressSection?.dprStatuses || [];

  const dprList = rawDprList.filter(
    item => !selectedLocation || Number(item.locationId) === Number(selectedLocation)
  );

  const dprMaterials = rawDprMaterials.filter(
    item => !selectedLocation || Number(item.locationId) === Number(selectedLocation)
  );

  const dprLabourDetails = rawDprLabourDetails.filter(
    item => !selectedLocation || Number(item.locationId) === Number(selectedLocation)
  );

  const filteredSkilled = dprLabourDetails.reduce((sum, item) => sum + Number(item.skilledLabour || 0), 0);
  const filteredUnskilled = dprLabourDetails.reduce((sum, item) => sum + Number(item.unSkilledLabour || 0), 0);
  const filteredTotal = filteredSkilled + filteredUnskilled;

  let currentDprStatus = "Not Created";
  if (selectedProject) {
    if (selectedLocation) {
      const match = rawDprStatuses.find(item => Number(item.locationId) === Number(selectedLocation));
      currentDprStatus = match ? match.status : "Not Created";
    } else {
      if (rawDprStatuses.length === 0) {
        currentDprStatus = "Not Created";
      } else if (rawDprStatuses.some(item => String(item.status).toLowerCase() === "pending")) {
        currentDprStatus = "Pending";
      } else if (rawDprStatuses.every(item => String(item.status).toLowerCase() === "approved")) {
        currentDprStatus = "Approved";
      } else {
        currentDprStatus = rawDprStatuses[0]?.status || "Not Created";
      }
    }
  } else {
    // If no project selected, show overall status based on all loaded reports
    if (rawDprStatuses.length === 0) {
      currentDprStatus = "Not Created";
    } else if (rawDprStatuses.some(item => String(item.status).toLowerCase() === "pending")) {
      currentDprStatus = "Pending";
    } else if (rawDprStatuses.every(item => String(item.status).toLowerCase() === "approved")) {
      currentDprStatus = "Approved";
    } else {
      currentDprStatus = rawDprStatuses[0]?.status || "Not Created";
    }
  }

  const handleCategoryChange = (catId) => {
    setSelectedCategory(catId);
    if (selectedProject && catId) {
      const currentProj = projects.find(p => Number(p.projectId) === Number(selectedProject));
      if (currentProj && Number(currentProj.projectCategoryId) !== Number(catId)) {
        setSelectedProject("");
        setSearchText("");
      }
    }
  };

  return (
    <div className="dashboard-container">
      <div className="d-flex justify-content-between align-items-start mb-3">
        <Breadcrumb pageTitle="Dashboard" />

        <div className="d-flex gap-3 align-items-center flex-wrap">
          {/* Project Category Selection */}
          <div className="corp-project-selector-wrapper corp-category-select-width">
            <label className="corp-project-selector-label">
              Select Category
            </label>
            <div className="position-relative d-flex align-items-center">
              <select
                className="form-select corp-category-select"
                style={{ paddingRight: selectedCategory ? "35px" : "12px" }}
                value={selectedCategory}
                onChange={(e) => handleCategoryChange(e.target.value)}
              >
                <option value="">All Categories</option>
                {projectCategories.map((cat) => (
                  <option key={cat.id} value={cat.id}>
                    {cat.categoryName}
                  </option>
                ))}
              </select>
              {selectedCategory && (
                <i
                  className="ti ti-x clear-icon-select"
                  onClick={() => handleCategoryChange("")}
                />
              )}
            </div>
          </div>

          {/* Project Selection */}
          <div className="corp-project-selector-wrapper corp-project-selector-350">
            <label className="corp-project-selector-label">
              Select Project
            </label>

            <div className="corp-input-group" onClick={(e) => e.stopPropagation()}>
              <i className="ti ti-search search-icon" />
              <input
                type="text"
                placeholder="Search or Select Project"
                value={searchText}
                onFocus={() => setShowDropdown(true)}
                onChange={(e) => setSearchText(e.target.value)}
              />
              {searchText && (
                <i
                  className="ti ti-x clear-icon"
                  onClick={() => {
                    setSelectedProject("");
                    setSearchText("");
                  }}
                />
              )}

              {showDropdown && (
                <div className="corp-dropdown-menu">
                  <div
                    className="corp-dropdown-item all-projects-btn"
                    onClick={() => {
                      setSelectedProject("");
                      setSearchText("");
                      setShowDropdown(false);
                    }}
                  >
                    All Projects
                  </div>

                  {projects
                    .filter((proj) => {
                      const matchesSearch = proj.projectName
                        .toLowerCase()
                        .includes(searchText.toLowerCase());
                      const matchesCategory = !selectedCategory || Number(proj.projectCategoryId) === Number(selectedCategory);
                      return matchesSearch && matchesCategory;
                    })
                    .map((proj) => (
                      <div
                        key={proj.projectId}
                        className="corp-dropdown-item"
                        onClick={() => {
                          setSelectedProject(proj.projectId);
                          setSearchText(`${proj.projectName} - ${proj.projectCode}`);
                          setShowDropdown(false);
                          if (proj.projectCategoryId) {
                            setSelectedCategory(proj.projectCategoryId);
                          }
                        }}
                      >
                        {proj.projectName} - {proj.projectCode}
                      </div>
                    ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="dashboard-loading-overlay">
          <div className="text-center">
            <div className="spinner-border text-primary" />
            <p className="fw-semibold text-dark mt-3 loading-text">Loading dashboard...</p>
          </div>
        </div>
      )}

      <Tabs>
        <TabList>
          {isSuperOrPm && (
            <Tab>
              <div className="row section-title-wrapper my-2">
                <div className="col-12">
                  <h4 className="section-title">Management Insights & Summary</h4>
                  <hr className="section-divider" />
                </div>
              </div>
            </Tab>
          )}
          <Tab>
            <div className="row section-title-wrapper my-2">
              <div className="col-12">
                <h4 className="section-title">Daily Progress Report</h4>
                <hr className="section-divider" />
              </div>
            </div>
          </Tab>
          <Tab>
            <div className="row section-title-wrapper my-2">
              <div className="col-12">
                <h4 className="section-title">Pending for Approvals</h4>
                <hr className="section-divider" />
              </div>
            </div>
          </Tab>
          <Tab>
            <div className="row section-title-wrapper my-2">
              <div className="col-12">
                <h4 className="section-title">Pending Entries</h4>
                <hr className="section-divider" />
              </div>
            </div>
          </Tab>
        </TabList>

        {isSuperOrPm && (
          <TabPanel>
            {dashboardData.extraSection && (
              <>
                <>


                  <div className="row g-4">
                    {/* PROJECT STATUS */}
                    <div className="col-xl-12 col-md-12">
                      <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#4f46e5", "--card-accent-bg": "#e0e7ff" }}>
                        <div className="card-header py-3">
                          <h5 className="mb-0 fw-semibold">
                            <i className="ph ph-presentation-chart card-icon" />
                            Project Status
                          </h5>
                        </div>
                        <div className="card-body p-0">
                          <div className="table-responsive table-scroll">
                            <table className="table align-middle mb-0">
                              <thead className="sticky-thead">
                                <tr>
                                  <th>Schedule Activity</th>
                                  <th>Unit</th>
                                  <th className="text-end">Survey Qty</th>
                                  <th className="text-end">Completion Qty</th>
                                  <th className="text-end">Balance Qty</th>
                                  <th className="text-end">Completion %</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(!dashboardData.extraSection.projectStatus || dashboardData.extraSection.projectStatus.length === 0) ? (
                                  <tr>
                                    <td colSpan="6" className="text-center text-muted py-4">
                                      No project status data found
                                    </td>
                                  </tr>
                                ) : (
                                  dashboardData.extraSection.projectStatus.map((item, idx) => {
                                    const surveyQty = Number(item.surveyQty || 0);
                                    const completionQty = Number(item.completionQty || 0);
                                    const completionPercent = surveyQty > 0 ? (completionQty / surveyQty) * 100 : 0;
                                    return (
                                      <tr key={idx}>
                                        <td className="fw-semibold">{item.scheduleActivity}</td>
                                        <td>{item.unit}</td>
                                        <td className="text-end">{surveyQty.toFixed(3)}</td>
                                        <td className="text-end text-success">{completionQty.toFixed(3)}</td>
                                        <td className="text-end text-primary fw-medium">{Number(item.balanceQty || 0).toFixed(3)}</td>
                                        <td className="text-end fw-bold text-success">{completionPercent.toFixed(2)}%</td>
                                      </tr>
                                    );
                                  })
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>


                  </div>
                </>
                <>
                  {(() => {
                    const materialStatus = dashboardData.extraSection?.materialStatus || {};
                    const originalList = Array.isArray(materialStatus) ? materialStatus : (materialStatus.original || []);
                    const scrapList = Array.isArray(materialStatus) ? [] : (materialStatus.scrap || []);
                    const reuseList = Array.isArray(materialStatus) ? [] : (materialStatus.reuse || []);
                    const siteBalanceList = materialStatus.siteBalance || [];

                    const uniqueLocations = Array.from(new Set(siteBalanceList.map(item => item.locationName).filter(Boolean)))
                      .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' }));
                    const uniqueCategories = Array.from(new Set(siteBalanceList.map(item => item.itemCategory).filter(Boolean)))
                      .sort((a, b) => a.localeCompare(b));
                    const uniqueItems = Array.from(new Set(siteBalanceList.map(item => item.itemName).filter(Boolean)))
                      .sort((a, b) => a.localeCompare(b));

                    const filteredSiteBalance = siteBalanceList.filter(item => {
                      const matchesLocation = !sbLocationFilter || item.locationName === sbLocationFilter;
                      const matchesCategory = !sbCategoryFilter || item.itemCategory === sbCategoryFilter;
                      const matchesItem = !sbItemFilter || item.itemName === sbItemFilter;
                      return matchesLocation && matchesCategory && matchesItem;
                    });

                    return (
                      <div className="row g-4 mt-2">
                        {/* MATERIAL STATUS */}
                        <div className="col-xl-12 col-md-12">
                          <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#d97706", "--card-accent-bg": "#fef3c7" }}>
                            <div className="card-header py-3">
                              <h5 className="mb-0 fw-semibold">
                                <i className="ph ph-package card-icon" />
                                Material Status
                              </h5>
                            </div>
                            <div className="card-body p-3">
                              <Tabs>
                                <TabList>
                                  <Tab><strong>Original</strong></Tab>
                                  <Tab><strong>Reuse</strong></Tab>
                                  <Tab><strong>Scrap</strong></Tab>
                                  <Tab><strong>Site Balance</strong></Tab>
                                  <Tab><strong>Excess Stockout</strong></Tab>
                                </TabList>

                                {/* ORIGINAL TAB PANEL */}
                                <TabPanel>
                                  <div className="table-responsive table-scroll mt-3">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead className="sticky-thead">
                                        <tr>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">Item Category</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">Item Name</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">UOM</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">Purchase Qty</th>
                                          <th colSpan="2" className="text-center bg-light fw-semibold">Transfer Qty</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">Consumed Qty</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">Available Qty</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">Min Shelf Qty</th>
                                        </tr>
                                        <tr>
                                          <th className="text-end bg-light fw-semibold">In Qty</th>
                                          <th className="text-end bg-light fw-semibold">Out Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {originalList.length === 0 ? (
                                          <tr>
                                            <td colSpan="9" className="text-center text-muted py-4">
                                              No items marked for dashboard display
                                            </td>
                                          </tr>
                                        ) : (
                                          originalList.map((item, idx) => {
                                            const isLowStock = Number(item.availableQty || 0) <= Number(item.minShelfQty || 0);
                                            return (
                                              <tr
                                                key={idx}
                                                className={isLowStock ? "table-danger" : ""}
                                                style={isLowStock ? { backgroundColor: "#fee2e2" } : undefined}
                                              >
                                                <td>{item.itemCategory}</td>
                                                <td className="fw-semibold">
                                                  {item.itemName}
                                                  {isLowStock && (
                                                    <span className="badge bg-danger ms-2" style={{ fontSize: "10px" }}>
                                                      Low Stock
                                                    </span>
                                                  )}
                                                </td>
                                                <td>{item.uom}</td>
                                                <td className="text-end">{Math.round(item.purchaseQty || 0)}</td>
                                                <td className="text-end text-success">{Math.round(item.transferInQty || 0)}</td>
                                                <td className="text-end">{Math.round(item.transferOutQty || 0)}</td>
                                                <td className="text-end">{Math.round(item.consumedQty || 0)}</td>
                                                <td className="text-end text-danger fw-bold">{Math.round(item.availableQty || 0)}</td>
                                                <td className="text-end fw-semibold">{Math.round(item.minShelfQty || 0)}</td>
                                              </tr>
                                            );
                                          })
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </TabPanel>

                                {/* REUSE TAB PANEL */}
                                <TabPanel>
                                  <div className="table-responsive table-scroll mt-3">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead className="sticky-thead">
                                        <tr>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">Item Category</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">Item Name</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">UOM</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">
                                            Received Qty
                                            <br />
                                            <span style={{ fontSize: '9px', fontWeight: 'normal', textTransform: 'none' }}>(from site)</span>
                                          </th>
                                          <th colSpan="2" className="text-center bg-light fw-semibold">Transfer Qty</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">Consumed Qty</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">Available Qty</th>
                                        </tr>
                                        <tr>
                                          <th className="text-end bg-light fw-semibold">In Qty</th>
                                          <th className="text-end bg-light fw-semibold">Out Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {reuseList.length === 0 ? (
                                          <tr>
                                            <td colSpan="8" className="text-center text-muted py-4">
                                              No reuse items found
                                            </td>
                                          </tr>
                                        ) : (
                                          reuseList.map((item, idx) => (
                                            <tr key={idx}>
                                              <td>{item.itemCategory}</td>
                                              <td className="fw-semibold">{item.itemName}</td>
                                              <td>{item.uom}</td>
                                              <td className="text-end">{Math.round(item.receivedQty || 0)}</td>
                                              <td className="text-end text-success">{Math.round(item.transferInQty || 0)}</td>
                                              <td className="text-end">{Math.round(item.transferOutQty || 0)}</td>
                                              <td className="text-end">{Math.round(item.consumedQty || 0)}</td>
                                              <td className="text-end text-danger fw-bold">{Math.round(item.availableQty || 0)}</td>
                                            </tr>
                                          ))
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </TabPanel>

                                {/* SCRAP TAB PANEL */}
                                <TabPanel>
                                  <div className="table-responsive table-scroll mt-3">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead className="sticky-thead">
                                        <tr>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">Item Category</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">Item Name</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold">UOM</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">
                                            Received Qty
                                            <br />
                                            <span style={{ fontSize: '9px', fontWeight: 'normal', textTransform: 'none' }}>(from site)</span>
                                          </th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">
                                            Return Qty
                                            <br />
                                            <span style={{ fontSize: '9px', fontWeight: 'normal', textTransform: 'none' }}>(from site)</span>
                                          </th>
                                          <th colSpan="2" className="text-center bg-light fw-semibold">Transfer Qty</th>
                                          <th rowSpan="2" className="align-middle text-end bg-light fw-semibold">Available Qty</th>
                                        </tr>
                                        <tr>
                                          <th className="text-end bg-light fw-semibold">In Qty</th>
                                          <th className="text-end bg-light fw-semibold">Out Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {scrapList.length === 0 ? (
                                          <tr>
                                            <td colSpan="8" className="text-center text-muted py-4">
                                              No scrap items found
                                            </td>
                                          </tr>
                                        ) : (
                                          scrapList.map((item, idx) => (
                                            <tr key={idx}>
                                              <td>{item.itemCategory}</td>
                                              <td className="fw-semibold">{item.itemName}</td>
                                              <td>{item.uom}</td>
                                              <td className="text-end">{Math.round(item.receivedQty || 0)}</td>
                                              <td className="text-end">{Math.round(item.returnQty || 0)}</td>
                                              <td className="text-end text-success">{Math.round(item.transferInQty || 0)}</td>
                                              <td className="text-end">{Math.round(item.transferOutQty || 0)}</td>
                                              <td className="text-end text-danger fw-bold">{Math.round(item.availableQty || 0)}</td>
                                            </tr>
                                          ))
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </TabPanel>

                                {/* SITE BALANCE TAB PANEL */}
                                <TabPanel>
                                  <div className="row g-2 mt-2 mb-2 p-2 bg-light rounded border align-items-end">
                                    <div className="col-md-3 col-sm-6">
                                      <label className="form-label sb-filter-label mb-1">Filter by Location</label>
                                      <div className="corp-input-group position-relative" onClick={(e) => e.stopPropagation()}>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm sb-filter-select"
                                          placeholder="Search Location..."
                                          value={locationSearch}
                                          onFocus={() => {
                                            setShowLocationDropdown(true);
                                            setShowCategoryDropdown(false);
                                            setShowItemDropdown(false);
                                          }}
                                          onChange={(e) => {
                                            setLocationSearch(e.target.value);
                                          }}
                                        />
                                        {locationSearch ? (
                                          <i
                                            className="ti ti-x clear-icon"
                                            style={{ top: "50%", transform: "translateY(-50%)", right: "12px", zIndex: 10, cursor: "pointer", position: "absolute" }}
                                            onClick={() => {
                                              setSbLocationFilter("");
                                              setLocationSearch("");
                                              setShowLocationDropdown(false);
                                            }}
                                          />
                                        ) : (
                                          <i
                                            className="ti ti-chevron-down text-muted"
                                            style={{ top: "50%", transform: "translateY(-50%)", right: "12px", zIndex: 10, position: "absolute", pointerEvents: "none" }}
                                          />
                                        )}
                                        {showLocationDropdown && (
                                          <div className="corp-dropdown-menu" style={{ width: "100%", maxHeight: "200px", overflowY: "auto", top: "100%" }}>
                                            <div
                                              className="corp-dropdown-item text-muted"
                                              onClick={() => {
                                                setSbLocationFilter("");
                                                setLocationSearch("");
                                                setShowLocationDropdown(false);
                                              }}
                                            >
                                              All Locations
                                            </div>
                                            {uniqueLocations
                                              .filter(loc => loc.toLowerCase().includes(locationSearch.toLowerCase()))
                                              .map((loc, i) => (
                                                <div
                                                  key={i}
                                                  className="corp-dropdown-item"
                                                  onClick={() => {
                                                    setSbLocationFilter(loc);
                                                    setLocationSearch(loc);
                                                    setShowLocationDropdown(false);
                                                  }}
                                                >
                                                  {loc}
                                                </div>
                                              ))}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3 col-sm-6">
                                      <label className="form-label sb-filter-label mb-1">Filter by Category</label>
                                      <div className="corp-input-group position-relative" onClick={(e) => e.stopPropagation()}>
                                        <input
                                          type="text"
                                          className="form-control form-control-sm sb-filter-select"
                                          placeholder="Search Category..."
                                          value={categorySearch}
                                          onFocus={() => {
                                            setShowLocationDropdown(false);
                                            setShowCategoryDropdown(true);
                                            setShowItemDropdown(false);
                                          }}
                                          onChange={(e) => {
                                            setCategorySearch(e.target.value);
                                          }}
                                        />
                                        {categorySearch ? (
                                          <i
                                            className="ti ti-x clear-icon"
                                            style={{ top: "50%", transform: "translateY(-50%)", right: "12px", zIndex: 10, cursor: "pointer", position: "absolute" }}
                                            onClick={() => {
                                              setSbCategoryFilter("");
                                              setCategorySearch("");
                                              setShowCategoryDropdown(false);
                                            }}
                                          />
                                        ) : (
                                          <i
                                            className="ti ti-chevron-down text-muted"
                                            style={{ top: "50%", transform: "translateY(-50%)", right: "12px", zIndex: 10, position: "absolute", pointerEvents: "none" }}
                                          />
                                        )}
                                        {showCategoryDropdown && (
                                          <div className="corp-dropdown-menu" style={{ width: "100%", maxHeight: "200px", overflowY: "auto", top: "100%" }}>
                                            <div
                                              className="corp-dropdown-item text-muted"
                                              onClick={() => {
                                                setSbCategoryFilter("");
                                                setCategorySearch("");
                                                setShowCategoryDropdown(false);
                                              }}
                                            >
                                              All Categories
                                            </div>
                                            {uniqueCategories
                                              .filter(cat => cat.toLowerCase().includes(categorySearch.toLowerCase()))
                                              .map((cat, i) => (
                                                <div
                                                  key={i}
                                                  className="corp-dropdown-item"
                                                  onClick={() => {
                                                    setSbCategoryFilter(cat);
                                                    setCategorySearch(cat);
                                                    setShowCategoryDropdown(false);
                                                  }}
                                                >
                                                  {cat}
                                                </div>
                                              ))}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3 col-sm-6">
                                      <label className="form-label sb-filter-label mb-1">Filter by Item</label>
                                      <div className="d-flex align-items-center gap-2">
                                        <div className="corp-input-group position-relative flex-grow-1" onClick={(e) => e.stopPropagation()}>
                                          <input
                                            type="text"
                                            className="form-control form-control-sm sb-filter-select"
                                            placeholder="Search Item..."
                                            value={itemSearch}
                                            onFocus={() => {
                                              setShowLocationDropdown(false);
                                              setShowCategoryDropdown(false);
                                              setShowItemDropdown(true);
                                            }}
                                            onChange={(e) => {
                                              setItemSearch(e.target.value);
                                            }}
                                          />
                                          {itemSearch ? (
                                            <i
                                              className="ti ti-x clear-icon"
                                              style={{ top: "50%", transform: "translateY(-50%)", right: "12px", zIndex: 10, cursor: "pointer", position: "absolute" }}
                                              onClick={() => {
                                                setSbItemFilter("");
                                                setItemSearch("");
                                                setShowItemDropdown(false);
                                              }}
                                            />
                                          ) : (
                                            <i
                                              className="ti ti-chevron-down text-muted"
                                              style={{ top: "50%", transform: "translateY(-50%)", right: "12px", zIndex: 10, position: "absolute", pointerEvents: "none" }}
                                            />
                                          )}
                                          {showItemDropdown && (
                                            <div className="corp-dropdown-menu" style={{ width: "100%", maxHeight: "200px", overflowY: "auto", top: "100%" }}>
                                              <div
                                                className="corp-dropdown-item text-muted"
                                                onClick={() => {
                                                  setSbItemFilter("");
                                                  setItemSearch("");
                                                  setShowItemDropdown(false);
                                                }}
                                              >
                                                All Items
                                              </div>
                                              {uniqueItems
                                                .filter(itm => itm.toLowerCase().includes(itemSearch.toLowerCase()))
                                                .map((itm, i) => (
                                                  <div
                                                    key={i}
                                                    className="corp-dropdown-item"
                                                    onClick={() => {
                                                      setSbItemFilter(itm);
                                                      setItemSearch(itm);
                                                      setShowItemDropdown(false);
                                                    }}
                                                  >
                                                    {itm}
                                                  </div>
                                                ))}
                                            </div>
                                          )}
                                        </div>
                                        {(sbLocationFilter || sbCategoryFilter || sbItemFilter) && (
                                          <i
                                            className="ti ti-x text-danger clear-all-small-btn"
                                            title="Clear all filters"
                                            onClick={() => {
                                              setSbLocationFilter("");
                                              setSbCategoryFilter("");
                                              setSbItemFilter("");
                                              setLocationSearch("");
                                              setCategorySearch("");
                                              setItemSearch("");
                                            }}
                                          />
                                        )}
                                      </div>
                                    </div>
                                    <div className="col-md-3 col-sm-12 text-end d-flex align-items-center justify-content-end" style={{ minHeight: "36px" }}>
                                      <span className="sb-total-count">Total: {filteredSiteBalance.length} items</span>
                                    </div>
                                  </div>

                                  <div className="table-responsive table-scroll mt-3">
                                    <table className="table table-bordered align-middle mb-0">
                                      <thead className="sticky-thead">
                                        <tr>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold" style={{ borderBottomWidth: '1px' }}>Location</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold" style={{ borderBottomWidth: '1px' }}>Item Category</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold" style={{ borderBottomWidth: '1px' }}>Item Name</th>
                                          <th rowSpan="2" className="align-middle bg-light fw-semibold" style={{ borderBottomWidth: '1px' }}>UOM</th>
                                          <th colSpan="2" className="text-center bg-light fw-semibold" style={{ borderBottomWidth: '2px' }}>Available Qty</th>
                                        </tr>
                                        <tr>
                                          <th className="text-end bg-light fw-semibold" style={{ borderTopWidth: '1px' }}>Original Qty</th>
                                          <th className="text-end bg-light fw-semibold" style={{ borderTopWidth: '1px' }}>Reuse Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {filteredSiteBalance.length === 0 ? (
                                          <tr>
                                            <td colSpan="6" className="text-center text-muted py-4">
                                              No site balance items found
                                            </td>
                                          </tr>
                                        ) : (
                                          filteredSiteBalance.map((item, idx) => (
                                            <tr key={idx}>
                                              <td>{item.locationName}</td>
                                              <td>{item.itemCategory}</td>
                                              <td className="fw-semibold">{item.itemName}</td>
                                              <td>{item.uom}</td>
                                              <td className="text-end text-primary fw-bold">{Math.round(item.originalQty || 0)}</td>
                                              <td className="text-end text-success fw-bold">{Math.round(item.reuseQty || 0)}</td>
                                            </tr>
                                          ))
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </TabPanel>

                                {/* PROJECT ESTIMATES TAB PANEL */}
                                <TabPanel>
                                  <div className="table-responsive table-scroll mt-3" style={{ maxHeight: "350px" }}>
                                    <table className="table align-middle mb-0">
                                      <thead className="sticky-thead">
                                        <tr>
                                          <th>Sr.No</th>
                                          <th>Project Category</th>
                                          <th>Project</th>
                                          <th>Location</th>
                                          <th>Item Category</th>
                                          <th>Item Name</th>
                                          <th>UOM</th>
                                          <th className="text-end">Estimated Qty</th>
                                          <th className="text-end">Total Out Qty</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {(!dashboardData.extraSection.projectEstimates || dashboardData.extraSection.projectEstimates.length === 0) ? (
                                          <tr>
                                            <td colSpan="9" className="text-center text-muted py-4">
                                              No items exceeding their estimated quantities found
                                            </td>
                                          </tr>
                                        ) : (
                                          dashboardData.extraSection.projectEstimates.map((item, idx) => (
                                            <tr key={idx}>
                                              <td>{idx + 1}</td>
                                              <td>{item.projectCategory || "-"}</td>
                                              <td>{item.project ? `${item.project}${item.projectCode ? `-${item.projectCode}` : ""}` : "-"}</td>
                                              <td>{item.location || "-"}</td>
                                              <td>{item.itemCategory || "-"}</td>
                                              <td>{item.item ? `${item.item}${item.itemCode ? ` (${item.itemCode})` : ""}` : "-"}</td>
                                              <td>{item.uom || "-"}</td>
                                              <td className="text-end fw-semibold text-danger">{Number(item.estimatedQty || 0).toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                              <td className="text-end fw-bold text-dark">{Number(item.totalOutQty || 0).toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            </tr>
                                          ))
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </TabPanel>
                              </Tabs>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })()}
                </>
                <>

                  <div className="row g-4 mt-2">

                    {/* FUEL DETAILS */}
                    <div className="col-xl-7 col-md-12">
                      <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#059669", "--card-accent-bg": "#d1fae5" }}>
                        <div className="card-header py-3">
                          <h5 className="mb-0 fw-semibold">
                            <i className="ph ph-gas-canister card-icon" />
                            Fuel Details
                          </h5>
                        </div>
                        <div className="card-body p-0">
                          <div className="table-responsive">
                            <table className="table align-middle mb-0 text-center">
                              <thead>
                                <tr>
                                  <th rowSpan="2" className="align-middle text-start ps-3">Item</th>
                                  <th colSpan="2" className="border-bottom">Purchase</th>
                                  <th colSpan="2" className="border-bottom">Consumption</th>
                                  <th colSpan="2" className="border-bottom">Balance</th>
                                </tr>
                                <tr>
                                  <th>Quantity</th>
                                  <th>Amount</th>
                                  <th>Quantity</th>
                                  <th>Amount</th>
                                  <th>Quantity</th>
                                  <th>Amount</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(!dashboardData.extraSection.fuelDetails || dashboardData.extraSection.fuelDetails.length === 0) ? (
                                  <tr>
                                    <td colSpan="7" className="text-center text-muted py-4">
                                      No fuel details found
                                    </td>
                                  </tr>
                                ) : (
                                  <>
                                    {dashboardData.extraSection.fuelDetails.map((item, idx) => (
                                      <tr key={idx}>
                                        <td className="text-start fw-semibold ps-3">{item.item}</td>
                                        <td>{Number(item.purchaseQty || 0).toLocaleString()}</td>
                                        <td>₹ {Number(item.purchaseAmt || 0).toLocaleString()}</td>
                                        <td>{Number(item.consumptionQty || 0).toLocaleString()}</td>
                                        <td>₹ {Number(item.consumptionAmt || 0).toLocaleString()}</td>
                                        <td className="text-primary fw-medium">{Number(item.balanceQty || 0).toLocaleString()}</td>
                                        <td className="text-primary fw-medium">₹ {Number(item.balanceAmt || 0).toLocaleString()}</td>
                                      </tr>
                                    ))}
                                    {/* TOTALS */}
                                    <tr className="row-muted-bg">
                                      <td className="text-start ps-3">Total:</td>
                                      <td>{dashboardData.extraSection.fuelDetails.reduce((sum, item) => sum + Number(item.purchaseQty || 0), 0).toLocaleString()}</td>
                                      <td>₹ {dashboardData.extraSection.fuelDetails.reduce((sum, item) => sum + Number(item.purchaseAmt || 0), 0).toLocaleString()}</td>
                                      <td>{dashboardData.extraSection.fuelDetails.reduce((sum, item) => sum + Number(item.consumptionQty || 0), 0).toLocaleString()}</td>
                                      <td>₹ {dashboardData.extraSection.fuelDetails.reduce((sum, item) => sum + Number(item.consumptionAmt || 0), 0).toLocaleString()}</td>
                                      <td>{dashboardData.extraSection.fuelDetails.reduce((sum, item) => sum + Number(item.balanceQty || 0), 0).toLocaleString()}</td>
                                      <td>₹ {dashboardData.extraSection.fuelDetails.reduce((sum, item) => sum + Number(item.balanceAmt || 0), 0).toLocaleString()}</td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* PETTY CASH EXPENDITURE */}
                    <div className="col-xl-5 col-md-12">
                      <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#e11d48", "--card-accent-bg": "#ffe4e6" }}>
                        <div className="card-header py-3">
                          <h5 className="mb-0 fw-semibold">
                            <i className="ph ph-coins card-icon" />
                            Petty Cash Payments
                          </h5>
                        </div>
                        <div className="card-body p-0">
                          <div className="table-responsive table-scroll">
                            <table className="table align-middle mb-0">
                              <thead className="sticky-thead">
                                <tr>
                                  <th>Employee Name</th>
                                  <th className="text-end">Total Receipt</th>
                                  <th className="text-end">Total Payments</th>
                                  <th className="text-end pe-3">Balance</th>
                                </tr>
                              </thead>
                              <tbody>
                                {(!dashboardData.extraSection.pettyCashExpenditure || dashboardData.extraSection.pettyCashExpenditure.length === 0) ? (
                                  <tr>
                                    <td colSpan="4" className="text-center text-muted py-4">
                                      No payments recorded
                                    </td>
                                  </tr>
                                ) : (
                                  <>
                                    {dashboardData.extraSection.pettyCashExpenditure.map((item, idx) => {
                                      const balance = Number(item.balanceAmount || 0);
                                      return (
                                        <tr key={idx}>
                                          <td className="fw-medium">{item.employeeName}</td>
                                          <td className="text-end text-success fw-semibold">{Number(item.receiptAmount || 0).toLocaleString()}</td>
                                          <td className="text-end text-danger fw-semibold">{Number(item.amount || 0).toLocaleString()}</td>
                                          <td className={`text-end fw-semibold pe-3 ${balance < 0 ? 'text-danger' : 'text-success'}`}>
                                            {balance < 0 ? '-' : ''}{Math.abs(balance).toLocaleString()}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                    {/* TOTAL */}
                                    <tr className="row-muted-bg">
                                      <td>Total:</td>
                                      <td className="text-end text-success fw-semibold">
                                        {dashboardData.extraSection.pettyCashExpenditure.reduce((sum, item) => sum + Number(item.receiptAmount || 0), 0).toLocaleString()}
                                      </td>
                                      <td className="text-end text-danger fw-semibold">
                                        {dashboardData.extraSection.pettyCashExpenditure.reduce((sum, item) => sum + Number(item.amount || 0), 0).toLocaleString()}
                                      </td>
                                      {(() => {
                                        const totalReceipt = dashboardData.extraSection.pettyCashExpenditure.reduce((sum, item) => sum + Number(item.receiptAmount || 0), 0);
                                        const totalPayment = dashboardData.extraSection.pettyCashExpenditure.reduce((sum, item) => sum + Number(item.amount || 0), 0);
                                        const totalBalance = totalReceipt - totalPayment;
                                        return (
                                          <td className={`text-end fw-semibold pe-3 ${totalBalance < 0 ? 'text-danger' : 'text-success'}`}>
                                            {totalBalance < 0 ? '-' : ''}{Math.abs(totalBalance).toLocaleString()}
                                          </td>
                                        );
                                      })()}
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* VEHICLE DUES */}
                    <div className="col-xl-5 col-md-12">
                      <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#0891b2", "--card-accent-bg": "#ecfeff" }}>
                        <div className="card-header py-3">
                          <h5 className="mb-0 fw-semibold">
                            <i className="ph ph-warning-circle card-icon" />
                            Vehicle Dues <span className="text-muted small-text">(15 Days)</span>
                          </h5>
                        </div>
                        <div className="card-body d-flex align-items-center p-3">
                          <div className="dues-grid">
                            <div
                              className="dues-box service"
                              style={{
                                "--dues-color": "#0284c7",
                                "--dues-bg-soft": "#e0f2fe",
                                cursor: "pointer",
                                transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out"
                              }}
                              onClick={() => handleShowDuesModal('Service', dashboardData.extraSection.vehicleDues?.serviceList)}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "none";
                                e.currentTarget.style.boxShadow = "none";
                              }}
                            >
                              <div className="dues-val">{dashboardData.extraSection.vehicleDues?.service || 0}</div>
                              <div className="dues-lbl">Service</div>
                            </div>
                            <div
                              className="dues-box tax"
                              style={{
                                "--dues-color": "#10b981",
                                "--dues-bg-soft": "#dcfce7",
                                cursor: "pointer",
                                transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out"
                              }}
                              onClick={() => handleShowDuesModal('Tax', dashboardData.extraSection.vehicleDues?.taxList)}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "none";
                                e.currentTarget.style.boxShadow = "none";
                              }}
                            >
                              <div className="dues-val">{dashboardData.extraSection.vehicleDues?.tax || 0}</div>
                              <div className="dues-lbl">Tax</div>
                            </div>
                            <div
                              className="dues-box insurance"
                              style={{
                                "--dues-color": "#f59e0b",
                                "--dues-bg-soft": "#fef3c7",
                                cursor: "pointer",
                                transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out"
                              }}
                              onClick={() => handleShowDuesModal('Insurance', dashboardData.extraSection.vehicleDues?.insuranceList)}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.transform = "translateY(-4px)";
                                e.currentTarget.style.boxShadow = "0 10px 15px -3px rgba(0, 0, 0, 0.1)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.transform = "none";
                                e.currentTarget.style.boxShadow = "none";
                              }}
                            >
                              <div className="dues-val">{dashboardData.extraSection.vehicleDues?.insurance || 0}</div>
                              <div className="dues-lbl">Insurance</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </>
            )}
          </TabPanel>
        )}
        <TabPanel>
          {dashboardData.dailyProgressSection && (
            <>
              <div className="row section-title-wrapper mx-1 align-items-center">
                <div className="col-md-8 col-12 d-flex align-items-center">
                  <h4 className="section-title mb-0">
                    {formatDisplayDate(selectedDate)}
                  </h4>
                </div>
                <div className="col-md-4 col-12 text-md-end mt-2 mt-md-0">
                  <div className="d-inline-flex align-items-center bg-white border rounded px-3 py-1 shadow-sm">
                    <i className="ph ph-calendar text-muted me-2" style={{ fontSize: '1.2rem', verticalAlign: 'middle' }} />
                    <input
                      type="date"
                      className="form-control border-0 p-0 shadow-none text-dark fw-semibold"
                      style={{ width: '135px', fontSize: '0.9rem', cursor: 'pointer', background: 'transparent' }}
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              <div className="row g-4">
                {/* DAILY PROGRESS REPORT */}
                <div className="col-xl-12 col-md-12">
                  <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#10b981", "--card-accent-bg": "#d1fae5" }}>
                    <div className="card-header py-3 d-flex justify-content-between align-items-center flex-wrap gap-2">
                      <h5 className="mb-0 fw-semibold d-flex align-items-center flex-wrap">
                        <i className="ph ph-calendar-check card-icon" />
                        Daily Progress Report
                        {selectedProject && selectedLocation && (
                          <span className={`badge ms-2 ${currentDprStatus.toLowerCase() === 'approved' ? 'bg-success' :
                            currentDprStatus.toLowerCase() === 'pending' ? 'bg-warning text-dark' :
                              currentDprStatus.toLowerCase() === 'not created' ? 'bg-secondary' :
                                'bg-info text-dark'
                            }`} style={{ fontSize: '0.8rem' }}>
                            {currentDprStatus}
                          </span>
                        )}
                      </h5>
                      <div className="d-flex align-items-center" style={{ minWidth: '220px' }}>
                        <span className="text-muted me-2" style={{ fontSize: '0.85rem', whiteSpace: 'nowrap' }}>Location:</span>
                        <select
                          className="form-select form-select-sm"
                          value={selectedLocation}
                          onChange={(e) => setSelectedLocation(e.target.value)}
                          style={{ borderRadius: '6px', cursor: 'pointer', boxShadow: 'none' }}
                        >
                          <option value="">All Locations</option>
                          {projectLocations.map(loc => (
                            <option key={loc.id} value={loc.locationId}>
                              {loc.locationName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="card-body p-3 d-flex flex-column">
                      <Tabs>
                        <TabList>
                          <Tab>Work Progress</Tab>
                          <Tab>Material Consumption</Tab>
                          <Tab>Working Labour</Tab>
                        </TabList>

                        {/* WORK PROGRESS PANEL */}
                        <TabPanel>
                          <div className="table-responsive table-scroll mt-2" style={{ maxHeight: "350px" }}>
                            <table className="table align-middle mb-0">
                              <thead className="sticky-thead">
                                <tr>
                                  <th>Sr.No</th>
                                  <th>Chainage(From-To)</th>
                                  <th>Work Item</th>
                                  <th>Work Activity</th>
                                  <th>Unit</th>
                                  <th>Side</th>
                                  <th className="text-end">Qty</th>
                                </tr>
                              </thead>
                              <tbody>
                                {dprList.length === 0 ? (
                                  <tr>
                                    <td colSpan="7" className="text-center text-muted py-4">
                                      No progress entries recorded for selected date
                                    </td>
                                  </tr>
                                ) : (
                                  dprList.map((item, idx) => (
                                    <tr key={idx}>
                                      <td>{idx + 1}</td>
                                      <td>{item.chainage}</td>
                                      <td className="fw-semibold">{item.workItem}</td>
                                      <td>{item.workActivity}</td>
                                      <td>{item.unit}</td>
                                      <td>
                                        <span className={`badge ${item.side?.toLowerCase() === 'left' ? 'bg-primary' : 'bg-success'}`}>
                                          {item.side}
                                        </span>
                                      </td>
                                      <td className="text-end fw-semibold text-dark">{Number(item.qty || 0).toFixed(3)}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </TabPanel>

                        {/* MATERIAL CONSUMPTION PANEL */}
                        <TabPanel>
                          <div className="table-responsive table-scroll mt-2" style={{ maxHeight: "350px" }}>
                            <table className="table align-middle mb-0">
                              <thead className="sticky-thead">
                                <tr>
                                  <th>Sr.No</th>
                                  <th>Voucher No</th>
                                  <th>Item Category</th>
                                  <th>Item Name</th>
                                  <th className="text-end">Issued</th>
                                  <th className="text-end">Used</th>
                                  <th className="text-end">Lost</th>
                                  <th className="text-end">Damaged</th>
                                  <th className="text-end">Returned</th>
                                  <th className="text-end">Site Balance</th>
                                  <th>Notes</th>
                                </tr>
                              </thead>
                              <tbody>
                                {dprMaterials.length === 0 ? (
                                  <tr>
                                    <td colSpan="11" className="text-center text-muted py-4">
                                      No material consumption entries recorded for selected date
                                    </td>
                                  </tr>
                                ) : (
                                  dprMaterials.map((item, idx) => (
                                    <tr key={idx}>
                                      <td>{idx + 1}</td>
                                      <td className="fw-semibold">{item.voucherNo}</td>
                                      <td>{item.itemCategoryName || item.itemCategory || "-"}</td>
                                      <td>{item.itemCode || item.itemName || "-"}</td>
                                      <td className="text-end text-success-emphasis fw-medium">{Number(item.issuedQty || 0).toFixed(3)}</td>
                                      <td className="text-end">{Number(item.quantityUsed || 0).toFixed(3)}</td>
                                      <td className="text-end">{Number(item.quantityLost || 0).toFixed(3)}</td>
                                      <td className="text-end">{Number(item.quantityDamaged || 0).toFixed(3)}</td>
                                      <td className="text-end">{Number(item.quantityReturned || 0).toFixed(3)}</td>
                                      <td className="text-end fw-semibold text-primary">{Number(item.siteBalance || 0).toFixed(3)}</td>
                                      <td>{item.notes}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </TabPanel>

                        {/* WORKING LABOUR PANEL */}
                        <TabPanel>
                          <div className="table-responsive table-scroll mt-2" style={{ maxHeight: "350px" }}>
                            <table className="table align-middle mb-0">
                              <thead className="sticky-thead">
                                <tr>
                                  <th>Sr.No</th>
                                  <th>Vendor Name</th>
                                  <th className="text-end">Skilled</th>
                                  <th className="text-end">Unskilled</th>
                                  <th className="text-end">Total</th>
                                  <th>Remarks</th>
                                </tr>
                              </thead>
                              <tbody>
                                {dprLabourDetails.length === 0 ? (
                                  <tr>
                                    <td colSpan="6" className="text-center text-muted py-4">
                                      No labour entries recorded for selected date
                                    </td>
                                  </tr>
                                ) : (
                                  dprLabourDetails.map((item, idx) => (
                                    <tr key={idx}>
                                      <td>{idx + 1}</td>
                                      <td className="fw-semibold">{item.vendorName}</td>
                                      <td className="text-end">{item.skilledLabour || 0}</td>
                                      <td className="text-end">{item.unSkilledLabour || 0}</td>
                                      <td className="text-end text-primary fw-medium">{item.totalLabour || 0}</td>
                                      <td>{item.remarks}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>
                        </TabPanel>
                      </Tabs>

                      {/* LABOUR DETAILS PANEL */}
                      <div className="labor-details-panel mt-3">
                        <span className="labor-details-title">Labour Details:</span>
                        <div className="labor-stat-container">
                          <div className="labor-stat-box">
                            <div className="labor-stat-num">{filteredSkilled}</div>
                            <div className="labor-stat-label">Skilled</div>
                          </div>
                          <div className="labor-stat-box">
                            <div className="labor-stat-num">{filteredUnskilled}</div>
                            <div className="labor-stat-label">Unskilled</div>
                          </div>
                          <div className="labor-stat-total">
                            <div className="labor-stat-num">{filteredTotal}</div>
                            <div className="labor-stat-label">Total</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


                {/* VEHICLE STATUS */}
                <div className="col-xl-6 col-md-12">
                  <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#0891b2", "--card-accent-bg": "#ecfeff" }}>
                    <div className="card-header py-3">
                      <h5 className="mb-0 fw-semibold">
                        <i className="ph ph-gauge card-icon" />
                        Vehicle Status
                      </h5>
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive table-scroll">
                        <table className="table align-middle mb-0 text-center">
                          <thead className="sticky-thead">
                            <tr>
                              <th className="text-start ps-3">Vehicle Type</th>
                              <th>Assigned</th>
                              <th>Working</th>
                              <th>Idle</th>
                              <th>Break Down</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(() => {
                              const rawVehicles = dashboardData.dailyProgressSection.vehicles || [];
                              const groups = {};
                              rawVehicles.forEach(v => {
                                const type = v.vehicleType;
                                if (!groups[type]) {
                                  groups[type] = {
                                    vehicleType: type,
                                    assigned: 0,
                                    working: 0,
                                    idle: 0,
                                    breakdown: 0,
                                    assignedList: [],
                                    workingList: [],
                                    idleList: [],
                                    breakdownList: []
                                  };
                                }

                                const g = groups[type];
                                g.assigned += 1;
                                g.assignedList.push(v);

                                const status = (v.workingStatus || "").toLowerCase();
                                if (status === 'working') {
                                  g.working += 1;
                                  g.workingList.push(v);
                                } else if (status === 'idle' || status === 'idel') {
                                  g.idle += 1;
                                  g.idleList.push(v);
                                } else if (status === 'breakdown') {
                                  g.breakdown += 1;
                                  g.breakdownList.push(v);
                                }
                              });

                              const aggregated = Object.values(groups);

                              if (aggregated.length === 0) {
                                return (
                                  <tr>
                                    <td colSpan="5" className="text-center text-muted py-4">
                                      No vehicle assignments found
                                    </td>
                                  </tr>
                                );
                              }

                              return (
                                <>
                                  {aggregated.map((item, idx) => (
                                    <tr key={idx}>
                                      <td className="text-start fw-semibold ps-3">{item.vehicleType}</td>
                                      <td
                                        className="fw-medium"
                                        style={{ cursor: item.assignedList.length > 0 ? "pointer" : "default" }}
                                        onClick={() => handleShowVehicleDetails(item.vehicleType, "Assigned", item.assignedList)}
                                        title={item.assignedList.length > 0 ? "Click to view vehicle details" : ""}
                                      >
                                        {item.assigned}
                                      </td>
                                      <td
                                        className="text-success fw-bold"
                                        style={{ cursor: item.workingList.length > 0 ? "pointer" : "default" }}
                                        onClick={() => handleShowVehicleDetails(item.vehicleType, "Working", item.workingList)}
                                        title={item.workingList.length > 0 ? "Click to view vehicle details" : ""}
                                      >
                                        {item.working}
                                      </td>
                                      <td
                                        className="text-warning fw-bold"
                                        style={{ cursor: item.idleList.length > 0 ? "pointer" : "default" }}
                                        onClick={() => handleShowVehicleDetails(item.vehicleType, "Idle", item.idleList)}
                                        title={item.idleList.length > 0 ? "Click to view vehicle details" : ""}
                                      >
                                        {item.idle}
                                      </td>
                                      <td
                                        className="text-danger fw-bold"
                                        style={{ cursor: item.breakdownList.length > 0 ? "pointer" : "default" }}
                                        onClick={() => handleShowVehicleDetails(item.vehicleType, "Breakdown", item.breakdownList)}
                                        title={item.breakdownList.length > 0 ? "Click to view vehicle details" : ""}
                                      >
                                        {item.breakdown}
                                      </td>
                                    </tr>
                                  ))}
                                  {/* TOTALS */}
                                  <tr className="row-muted-bg">
                                    <td className="text-start ps-3">Total:</td>
                                    <td
                                      className="fw-bold"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleShowVehicleDetails("Total Vehicle", "Assigned", aggregated.flatMap(i => i.assignedList))}
                                      title="Click to view vehicle details"
                                    >
                                      {aggregated.reduce((sum, item) => sum + Number(item.assigned || 0), 0)}
                                    </td>
                                    <td
                                      className="text-success fw-bold"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleShowVehicleDetails("Total Vehicle", "Working", aggregated.flatMap(i => i.workingList))}
                                      title="Click to view vehicle details"
                                    >
                                      {aggregated.reduce((sum, item) => sum + Number(item.working || 0), 0)}
                                    </td>
                                    <td
                                      className="text-warning fw-bold"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleShowVehicleDetails("Total Vehicle", "Idle", aggregated.flatMap(i => i.idleList))}
                                      title="Click to view vehicle details"
                                    >
                                      {aggregated.reduce((sum, item) => sum + Number(item.idle || 0), 0)}
                                    </td>
                                    <td
                                      className="text-danger fw-bold"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleShowVehicleDetails("Total Vehicle", "Breakdown", aggregated.flatMap(i => i.breakdownList))}
                                      title="Click to view vehicle details"
                                    >
                                      {aggregated.reduce((sum, item) => sum + Number(item.breakdown || 0), 0)}
                                    </td>
                                  </tr>
                                </>
                              );
                            })()}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {/* FUEL DETAILS (DAILY) */}
                <div className="col-xl-6 col-md-12">
                  <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#7f8691", "--card-accent-bg": "#8b8f94" }}>
                    <div className="card-header py-3">
                      <h5 className="mb-0 fw-semibold">
                        <i className="ph ph-gas-pump card-icon" />
                        Fuel Details <span className="text-muted small-text">({formatDisplayDate(selectedDate)})</span>
                      </h5>
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive">
                        <table className="table align-middle mb-0 text-center">
                          <thead>
                            <tr>
                              <th rowSpan="2" className="align-middle text-start ps-3">Item</th>
                              <th colSpan="2" className="border-bottom">Purchase</th>
                              <th colSpan="2" className="border-bottom">Consumption</th>
                              <th colSpan="2" className="border-bottom">Balance</th>
                            </tr>
                            <tr>
                              <th>Quantity</th>
                              <th>Amount</th>
                              <th>Quantity</th>
                              <th>Amount</th>
                              <th>Quantity</th>
                              <th>Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(!dashboardData.dailyProgressSection.fuel || dashboardData.dailyProgressSection.fuel.length === 0) ? (
                              <tr>
                                <td colSpan="7" className="text-center text-muted py-4">
                                  No fuel details found for today
                                </td>
                              </tr>
                            ) : (
                              <>
                                {dashboardData.dailyProgressSection.fuel.map((item, idx) => (
                                  <tr key={idx}>
                                    <td className="text-start fw-semibold ps-3">{item.item}</td>
                                    <td>{Number(item.purchaseQty || 0).toLocaleString()}</td>
                                    <td>₹ {Number(item.purchaseAmt || 0).toLocaleString()}</td>
                                    <td>{Number(item.consumptionQty || 0).toLocaleString()}</td>
                                    <td>₹ {Number(item.consumptionAmt || 0).toLocaleString()}</td>
                                    <td className="text-primary fw-medium">{Number(item.balanceQty || 0).toLocaleString()}</td>
                                    <td className="text-primary fw-medium">₹ {Number(item.balanceAmt || 0).toLocaleString()}</td>
                                  </tr>
                                ))}
                                {/* TOTALS */}
                                <tr className="row-muted-bg">
                                  <td className="text-start ps-3">Total:</td>
                                  <td>{dashboardData.dailyProgressSection.fuel.reduce((sum, item) => sum + Number(item.purchaseQty || 0), 0).toLocaleString()}</td>
                                  <td>₹ {dashboardData.dailyProgressSection.fuel.reduce((sum, item) => sum + Number(item.purchaseAmt || 0), 0).toLocaleString()}</td>
                                  <td>{dashboardData.dailyProgressSection.fuel.reduce((sum, item) => sum + Number(item.consumptionQty || 0), 0).toLocaleString()}</td>
                                  <td>₹ {dashboardData.dailyProgressSection.fuel.reduce((sum, item) => sum + Number(item.consumptionAmt || 0), 0).toLocaleString()}</td>
                                  <td>{dashboardData.dailyProgressSection.fuel.reduce((sum, item) => sum + Number(item.balanceQty || 0), 0).toLocaleString()}</td>
                                  <td>₹ {dashboardData.dailyProgressSection.fuel.reduce((sum, item) => sum + Number(item.balanceAmt || 0), 0).toLocaleString()}</td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* PETTY CASH EXPENDITURE (DAILY) */}
                <div className="col-xl-6 col-md-12">
                  <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#e11d48", "--card-accent-bg": "#ffe4e6" }}>
                    <div className="card-header py-3">
                      <h5 className="mb-0 fw-semibold">
                        <i className="ph ph-wallet card-icon" />
                        Petty Cash <span className="text-muted small-text">({formatDisplayDate(selectedDate)})</span>
                      </h5>
                    </div>
                    <div className="card-body p-0">
                      <div className="table-responsive table-scroll">
                        <table className="table align-middle mb-0">
                          <thead className="sticky-thead">
                            <tr>
                              <th>Employee Name</th>
                              <th className="text-end pe-3">Total Payments</th>
                            </tr>
                          </thead>
                          <tbody>
                            {(!dashboardData.dailyProgressSection.pettyCash || dashboardData.dailyProgressSection.pettyCash.length === 0) ? (
                              <tr>
                                <td colSpan="2" className="text-center text-muted py-4">
                                  No payments recorded for selected date
                                </td>
                              </tr>
                            ) : (
                              <>
                                {dashboardData.dailyProgressSection.pettyCash.map((item, idx) => {
                                  return (
                                    <tr key={idx}>
                                      <td className="fw-medium">{item.employeeName}</td>
                                      <td className="text-end text-danger fw-semibold pe-3">{Number(item.amount || 0).toLocaleString()}</td>
                                    </tr>
                                  );
                                })}
                                {/* TOTAL */}
                                <tr className="row-muted-bg">
                                  <td>Total:</td>
                                  <td className="text-end text-danger fw-semibold pe-3">
                                    {dashboardData.dailyProgressSection.pettyCash.reduce((sum, item) => sum + Number(item.amount || 0), 0).toLocaleString()}
                                  </td>
                                </tr>
                              </>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </>
          )}

          <hr className="my-4 text-muted section-divider" />

          <div className="row mt-4 g-4">
            {/* <div className="col-xl-4 col-md-6">
          <div className="corp-kpi-card" style={{ "--kpi-accent": "#0d9488", "--kpi-bg": "#ccfbf1", "--kpi-color": "#0d9488", "--kpi-gradient": "linear-gradient(90deg, #0d9488, #2dd4bf)" }}>
            <div className="kpi-indicator" />
            <div className="kpi-header">
              <div>
                <div className="kpi-title">Today's Fuel Expenses</div>
                <h3 className="kpi-value">₹ {Number(dashboardData.fuelExpenseToday ?? 0).toLocaleString()}</h3>
              </div>
              <div className="kpi-icon-container">
                <i className="ph ph-money-wavy" />
              </div>
            </div>
            <div className="kpi-progress">
              <div className="kpi-progress-bar" style={{ width: "100%" }} />
            </div>
          </div>
        </div> */}
            {/* <div className="col-xl-4 col-md-6">
          <div className="corp-kpi-card" style={{ "--kpi-accent": "#8b5cf6", "--kpi-bg": "#ede9fe", "--kpi-color": "#8b5cf6", "--kpi-gradient": "linear-gradient(90deg, #8b5cf6, #a78bfa)" }}>
            <div className="kpi-indicator" />
            <div className="kpi-header">
              <div>
                <div className="kpi-title">Total Petty Cash Balance</div>
                <h3 className="kpi-value">₹ {Number(dashboardData.totalPettyCashBalance ?? 0).toLocaleString()}</h3>
              </div>
              <div className="kpi-icon-container">
                <i className="ph ph-hand-coins" />
              </div>
            </div>
            <div className="kpi-progress">
              <div className="kpi-progress-bar" style={{ width: "100%" }} />
            </div>
          </div>
        </div> */}
            {/* <div className="col-xl-4 col-md-12">
          <div className="corp-kpi-card" style={{ "--kpi-accent": "#f43f5e", "--kpi-bg": "#ffe4e6", "--kpi-color": "#f43f5e", "--kpi-gradient": "linear-gradient(90deg, #f43f5e, #fda4af)" }}>
            <div className="kpi-indicator" />
            <div className="kpi-header">
              <div>
                <div className="kpi-title">Todays Petty Cash Used</div>
                <h3 className="kpi-value">₹ {Number(dashboardData.todaysPettyCashUsed ?? 0).toLocaleString()}</h3>
              </div>
              <div className="kpi-icon-container">
                <i className="ph ph-hand-withdraw" />
              </div>
            </div>
            <div className="kpi-progress">
              <div className="kpi-progress-bar" style={{ width: "100%" }} />
            </div>
          </div>
        </div> */}

            {/* <div className="col-xl-4 col-md-12">
          <div className="corp-kpi-card" style={{ "--kpi-accent": "#f59e0b", "--kpi-bg": "#fef3c7", "--kpi-color": "#f59e0b", "--kpi-gradient": "linear-gradient(90deg, #f59e0b, #fbbf24)" }}>
            <div className="kpi-indicator" />
            <div className="kpi-header">
              <div>
                <div className="kpi-title">Upcoming Vehicle Dues (15 Days)</div>
                <h3 className="kpi-value">{dashboardData.upcomingTotal ?? 0}</h3>
              </div>
              <div className="kpi-icon-container">
                <i className="ti ti-truck" />
              </div>
            </div>
            <div className="kpi-split-row">
              <div className="kpi-split-col">
                <div className="kpi-split-title">Insurance</div>
                <div className="kpi-split-value">{dashboardData.upcomingInsurance ?? 0}</div>
                <div className="kpi-progress" style={{ margin: "6px 12px 0 12px" }}>
                  <div className="kpi-progress-bar" style={{ width: "100%", background: "#a78bfa" }} />
                </div>
              </div>
              <div className="kpi-split-col">
                <div className="kpi-split-title">Tax</div>
                <div className="kpi-split-value">{dashboardData.upcomingTax ?? 0}</div>
                <div className="kpi-progress" style={{ margin: "6px 12px 0 12px" }}>
                  <div className="kpi-progress-bar" style={{ width: "100%", background: "#38b9e7" }} />
                </div>
              </div>
            </div>
          </div>
        </div> */}
            {/* <div className="col-xl-4 col-md-6">
          <div className="corp-kpi-card" style={{ "--kpi-accent": "#06b6d4", "--kpi-bg": "#ecfeff", "--kpi-color": "#06b6d4", "--kpi-gradient": "linear-gradient(90deg, #06b6d4, #22d3ee)" }}>
            <div className="kpi-indicator" />
            <div className="kpi-header">
              <div>
                <div className="kpi-title">Vehicle Summary</div>
                <h3 className="kpi-value">{dashboardData.totalVehicles ?? 0}</h3>
              </div>
              <div className="kpi-icon-container">
                <i className="ti ti-truck-delivery" />
              </div>
            </div>
            <div className="kpi-split-row">
              <div className="kpi-split-col">
                <div className="kpi-split-title">Available</div>
                <div className="kpi-split-value text-success">{dashboardData.availableVehicles ?? 0}</div>
                <div className="kpi-progress" style={{ margin: "6px 12px 0 12px" }}>
                  <div className="kpi-progress-bar" style={{ width: "100%", background: "#10b981" }} />
                </div>
              </div>
              <div className="kpi-split-col">
                <div className="kpi-split-title">Assigned</div>
                <div className="kpi-split-value text-warning">{dashboardData.assignedVehicles ?? 0}</div>
                <div className="kpi-progress" style={{ margin: "6px 12px 0 12px" }}>
                  <div className="kpi-progress-bar" style={{ width: "100%", background: "#f59e0b" }} />
                </div>
              </div>
            </div>
          </div>
        </div> */}

            {/* <div className="col-xl-4 col-md-6">
          <div className="corp-kpi-card" style={{ "--kpi-accent": "#3b82f6", "--kpi-bg": "#eff6ff", "--kpi-color": "#3b82f6", "--kpi-gradient": "linear-gradient(90deg, #3b82f6, #60a5fa)" }}>
            <div className="kpi-indicator" />
            <div className="kpi-header" style={{ marginBottom: "10px" }}>
              <div>
                <div className="kpi-title">Projects Summary</div>
                <h3 className="kpi-value">{dashboardData.totalProjects ?? 0}</h3>
              </div>
              <div className="kpi-icon-container">
                <i className="ph ph-pencil-ruler" />
              </div>
            </div>
            <div className="kpi-split-row" style={{ marginTop: "10px", paddingTop: "10px" }}>
              <div className="kpi-split-col">
                <div className="kpi-split-title">Ongoing</div>
                <div className="kpi-split-value text-primary">{dashboardData.ongoingProjects ?? 0}</div>
              </div>
              <div className="kpi-split-col">
                <div className="kpi-split-title">Total Registered</div>
                <div className="kpi-split-value">{dashboardData.totalProjects ?? 0}</div>
              </div>
            </div>
          </div>
        </div> */}
          </div>

          <div className="row  g-4">
            {/* VEHICLE TRANSFER CARD */}
            <div className="col-xl-12 col-md-12">
              <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#6366f1", "--card-accent-bg": "#ede9fe" }}>
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-3">
                      <div className="transfer-icon-box">
                        <i className="ti ti-arrows-transfer-up transfer-icon" />
                      </div>
                      <div>
                        <h5 className="mb-0 fw-semibold transfer-title">Vehicle Transfers</h5>
                        <small className="text-muted">Total Requests Processed</small>
                      </div>
                    </div>
                    <h3 className="mb-0 fw-bold transfer-count">
                      {dashboardData.vehicleTransferSummary?.total || 0}
                    </h3>
                  </div>

                  <div className="row text-center g-3">
                    {[
                      { label: "Pending", value: dashboardData.vehicleTransferSummary?.pending, color: "#0284c7", bg: "#e0f2fe" },
                      { label: "Approved", value: dashboardData.vehicleTransferSummary?.approved, color: "#10b981", bg: "#dcfce7" },
                      { label: "Rejected", value: dashboardData.vehicleTransferSummary?.rejected, color: "#ef4444", bg: "#fee2e2" },
                      { label: "Received", value: dashboardData.vehicleTransferSummary?.received, color: "#64748b", bg: "#f1f5f9" }
                    ].map((item, i) => (
                      <div className="col-3" key={i}>
                        <div className="transfer-summary-box" style={{ "--box-accent": item.color, "--box-bg": item.bg }}>
                          <div className="transfer-summary-val" style={{ color: item.color }}>
                            {item.value || 0}
                          </div>
                          <div className="transfer-summary-lbl">
                            {item.label}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* RECENT TRANSFERS TABLE */}
            <div className="col-xl-12 col-md-12">
              <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#6366f1", "--card-accent-bg": "#ede9fe" }}>
                <div className="card-header py-3">
                  <h5 className="mb-0 fw-semibold">
                    <i className="ph ph-clock-counter-clockwise card-icon" />
                    Recent Vehicle Transfers
                  </h5>
                </div>

                <div className="card-body p-0">
                  <div className={(dashboardData.recentTransfers || []).length > 3 ? 'table-scroll' : ''}>
                    <table className="table align-middle mb-0">
                      <thead>
                        <tr>
                          <th>Project</th>
                          <th>Vehicle</th>
                          <th>Status</th>
                          <th>Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(dashboardData.recentTransfers || []).length === 0 ? (
                          <tr>
                            <td colSpan="4" className="text-center text-muted py-4">
                              No transfers found
                            </td>
                          </tr>
                        ) : (
                          dashboardData.recentTransfers.map((item) => (
                            <tr key={item.id}>
                              <td className="fw-semibold">{item.projectName}</td>
                              <td>{item.vehicleType}</td>
                              <td>
                                <span className={`badge ${getStatusClass(item.status)}`}>
                                  {item.status}
                                </span>
                              </td>
                              <td className="text-muted-small">
                                {formatDate(item.requestedDate)}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>

        {/* TabPanel 3: Pending for Approves */}
        <TabPanel>
          <div className="row g-4">
            {/* PENDING STOCK TRANSACTIONS CARD WITH NESTED TABS */}
            <div className="col-12">
              <div className="card corp-card-premium" style={{ "--card-accent": "#3b82f6", "--card-accent-bg": "#dbeafe" }}>
                <div className="card-header py-3">
                  <h5 className="mb-0 fw-semibold">
                    <i className="ph ph-arrows-left-right card-icon" />
                    Pending Stock Transactions
                  </h5>
                </div>
                <div className="card-body p-3">
                  <Tabs>
                    <TabList>
                      <Tab><strong>Stock In</strong></Tab>
                      <Tab><strong>Stock Out</strong></Tab>
                      <Tab><strong>Stock Transfer</strong></Tab>
                      <Tab><strong>Stock Return</strong></Tab>
                      <Tab><strong>Stock Sales</strong></Tab>
                    </TabList>

                    {/* PENDING STOCK IN */}
                    <TabPanel>
                      <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                        <table className="table align-middle mb-0">
                          <thead className="sticky-thead">
                            <tr>
                              <th>Sr.No</th>
                              <th>Date</th>
                              <th>Project Category</th>
                              <th>Project</th>
                              <th>Store</th>
                              <th>Voucher No</th>
                              <th>Created By</th>
                              <th>Status</th>
                              <th>Project Manager</th>
                              <th>Approver</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pendingStockIn.length === 0 ? (
                              <tr>
                                <td colSpan="10" className="text-center text-muted py-4">
                                  No pending Stock In records found
                                </td>
                              </tr>
                            ) : (
                              pendingStockIn.map((item, idx) => (
                                <tr key={item.id}>
                                  <td>{idx + 1}</td>
                                  <td>{formatDate(item.receivedDate)}</td>
                                  <td>{item.projectCategoryName || "-"}</td>
                                  <td>{item.projectName || "-"}</td>
                                  <td>{item.storeName || "-"}</td>
                                  <td className="fw-semibold">{item.vocherNo || item.invoiceNo || "-"}</td>
                                  <td>{item.createdByName || "-"}</td>
                                  <td>
                                    <span className="badge bg-warning text-dark">{item.status}</span>
                                  </td>
                                  <td>{item.projectManagerName || "-"}</td>
                                  <td>{item.approveByName || "-"}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>

                    {/* PENDING STOCK OUT */}
                    <TabPanel>
                      <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                        <table className="table align-middle mb-0">
                          <thead className="sticky-thead">
                            <tr>
                              <th>Sr.No</th>
                              <th>Date</th>
                              <th>Project Category</th>
                              <th>Project</th>
                              <th>Store</th>
                              <th>Voucher No</th>
                              <th>Created By</th>
                              <th>Status</th>
                              <th>Project Manager</th>
                              <th>Approver</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pendingStockOut.length === 0 ? (
                              <tr>
                                <td colSpan="10" className="text-center text-muted py-4">
                                  No pending Stock Out records found
                                </td>
                              </tr>
                            ) : (
                              pendingStockOut.map((item, idx) => (
                                <tr key={item.id}>
                                  <td>{idx + 1}</td>
                                  <td>{formatDate(item.transactionDate)}</td>
                                  <td>{item.projectCategoryName || "-"}</td>
                                  <td>{item.projectName || "-"}</td>
                                  <td>{item.storeName || "-"}</td>
                                  <td className="fw-semibold">{item.vocherNo || "-"}</td>
                                  <td>{item.createdByName || "-"}</td>
                                  <td>
                                    <span className="badge bg-warning text-dark">{item.status}</span>
                                  </td>
                                  <td>{item.projectManagerName || "-"}</td>
                                  <td>{item.approveByName || "-"}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>

                    {/* PENDING STOCK TRANSFER */}
                    <TabPanel>
                      <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                        <table className="table align-middle mb-0">
                          <thead className="sticky-thead">
                            <tr>
                              <th>Sr.No</th>
                              <th>Date</th>
                              <th>Project Category</th>
                              <th>Project</th>
                              <th>Store</th>
                              <th>Voucher No</th>
                              <th>Created By</th>
                              <th>Status</th>
                              <th>Project Manager</th>
                              <th>Approver</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pendingStockTransfer.length === 0 ? (
                              <tr>
                                <td colSpan="10" className="text-center text-muted py-4">
                                  No pending or in-transit Stock Transfer records found
                                </td>
                              </tr>
                            ) : (
                              pendingStockTransfer.map((item, idx) => (
                                <tr key={item.id}>
                                  <td>{idx + 1}</td>
                                  <td>{formatDate(item.transferDate)}</td>
                                  <td>{item.fromProjectCategoryName || "-"} → {item.toProjectCategoryName || "-"}</td>
                                  <td>
                                    {item.fromProjectName} → {item.toProjectName}
                                    {item.fromProjectId === item.toProjectId ? (
                                      <span className="badge bg-success-subtle text-success border border-success-subtle ms-2" style={{ fontSize: '0.7rem', padding: '2.5px 6px' }}>Internal</span>
                                    ) : (
                                      <span className="badge bg-primary-subtle text-primary border border-primary-subtle ms-2" style={{ fontSize: '0.7rem', padding: '2.5px 6px' }}>External</span>
                                    )}
                                  </td>
                                  <td>{item.fromStoreName} → {item.toStoreName}</td>
                                  <td className="fw-semibold">{item.vocherNo || "-"}</td>
                                  <td>{item.createdByName || "-"}</td>
                                  <td>
                                    <span className={`badge ${item.status === 'intransit' ? 'bg-primary' : 'bg-warning text-dark'}`}>
                                      {item.status}
                                    </span>
                                  </td>
                                  <td>{item.projectManagerName || "-"}</td>
                                  <td>{item.approveByName || "-"}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>

                    {/* PENDING STOCK RETURN */}
                    <TabPanel>
                      <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                        <table className="table align-middle mb-0">
                          <thead className="sticky-thead">
                            <tr>
                              <th>Sr.No</th>
                              <th>Date</th>
                              <th>Project Category</th>
                              <th>Project</th>
                              <th>Store</th>
                              <th>Voucher No</th>
                              <th>Created By</th>
                              <th>Status</th>
                              <th>Project Manager</th>
                              <th>Approver</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pendingStockReturn.length === 0 ? (
                              <tr>
                                <td colSpan="10" className="text-center text-muted py-4">
                                  No pending Stock Return records found
                                </td>
                              </tr>
                            ) : (
                              pendingStockReturn.map((item, idx) => (
                                <tr key={item.id}>
                                  <td>{idx + 1}</td>
                                  <td>{formatDate(item.returnDate)}</td>
                                  <td>{item.projectCategoryName || "-"}</td>
                                  <td>{item.projectName || "-"}</td>
                                  <td>{item.storeName || "-"}</td>
                                  <td className="fw-semibold">{item.vocherNo || "-"}</td>
                                  <td>{item.createdByName || "-"}</td>
                                  <td>
                                    <span className="badge bg-warning text-dark">{item.status}</span>
                                  </td>
                                  <td>{item.projectManagerName || "-"}</td>
                                  <td>{item.approveByName || "-"}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>



                    {/* PENDING STOCK SALES */}
                    <TabPanel>
                      <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                        <table className="table align-middle mb-0">
                          <thead className="sticky-thead">
                            <tr>
                              <th>Sr.No</th>
                              <th>Date</th>
                              <th>Project Category</th>
                              <th>Project</th>
                              <th>Store</th>
                              <th>Voucher No</th>
                              <th>Created By</th>
                              <th>Status</th>
                              <th>Project Manager</th>
                              <th>Approver</th>
                            </tr>
                          </thead>
                          <tbody>
                            {pendingStockSales.length === 0 ? (
                              <tr>
                                <td colSpan="10" className="text-center text-muted py-4">
                                  No pending Stock Sales records found
                                </td>
                              </tr>
                            ) : (
                              pendingStockSales.map((item, idx) => (
                                <tr key={item.id}>
                                  <td>{idx + 1}</td>
                                  <td>{formatDate(item.saleDate)}</td>
                                  <td>{item.projectCategoryName || "-"}</td>
                                  <td>{item.projectName || "-"}</td>
                                  <td>{item.storeName || "-"}</td>
                                  <td className="fw-semibold">{item.invoiceNo || "-"}</td>
                                  <td>{item.createdByName || "-"}</td>
                                  <td>
                                    <span className="badge bg-warning text-dark">{item.status}</span>
                                  </td>
                                  <td>{item.projectManagerName || "-"}</td>
                                  <td>{item.approveByName || "-"}</td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
            {/* PENDING DPR (Always Visible) */}
            <div className="col-12">
              <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#0d9488", "--card-accent-bg": "#ccfbf1" }}>
                <div className="card-header py-3">
                  <h5 className="mb-0 fw-semibold">
                    <i className="ph ph-calendar-blank card-icon" />
                    Pending DPR
                  </h5>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                    <table className="table align-middle mb-0">
                      <thead className="sticky-thead">
                        <tr>
                          <th>Sr.No</th>
                          <th>Report Date</th>
                          <th>Project Category</th>
                          <th>Project</th>
                          <th>Location</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingDPR.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center text-muted py-4">
                              No pending DPR records found
                            </td>
                          </tr>
                        ) : (
                          pendingDPR.map((item, idx) => (
                            <tr key={item.id} onClick={() => handleShowDPRModal(item)} style={{ cursor: "pointer" }} className="hover-table-row">
                              <td>{idx + 1}</td>
                              <td>{formatDate(item.reportDate)}</td>
                              <td>{item.projectCategoryName || "-"}</td>
                              <td>{item.projectName}</td>
                              <td>{item.locationName}</td>
                              <td>
                                <span className="badge bg-warning text-dark">{item.status}</span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>

        {/* TabPanel 4: Pending for Entry */}
        <TabPanel>
          <div className="row g-4">
            {/* PENDING FOR RECEIVE STOCK RETURN */}
            <div className="col-12">
              <div className="card corp-card-premium" style={{ "--card-accent": "#ec4899", "--card-accent-bg": "#fce7f3" }}>
                <div className="card-header py-3">
                  <h5 className="mb-0 fw-semibold">
                    <i className="ph ph-receipt card-icon" />
                    Pending for Receive Stock Return
                  </h5>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                    <table className="table align-middle mb-0">
                      <thead className="sticky-thead">
                        <tr>
                          <th>Sr.No</th>
                          <th>Date</th>
                          <th>Project Category</th>
                          <th>Project</th>
                          <th>Location</th>
                          <th>Voucher No</th>
                          <th>Item Type</th>
                          <th>Item Code</th>
                          <th>Return Qty</th>
                          <th>Damaged Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingReceiveStockReturn.length === 0 ? (
                          <tr>
                            <td colSpan="10" className="text-center text-muted py-4">
                              No records found pending for receive Stock Return
                            </td>
                          </tr>
                        ) : (
                          pendingReceiveStockReturn.map((item, idx) => (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              <td>{formatDate(item.date)}</td>
                              <td>{item.projectCategory || "-"}</td>
                              <td>{item.project ? `${item.project}${item.projectCode ? `-${item.projectCode}` : ""}` : "-"}</td>
                              <td>{item.location || "-"}</td>
                              <td className="fw-semibold">{item.voucherNo || "-"}</td>
                              <td>{item.itemType || "-"}</td>
                              <td>{item.itemCode || "-"}</td>
                              <td>{Number(item.returnQty || 0).toLocaleString()}</td>
                              <td>{Number(item.damagedQty || 0).toLocaleString()}</td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* PENDING VEHICLE READINGS */}
            <div className="col-12">
              <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#f59e0b", "--card-accent-bg": "#fef3c7" }}>
                <div className="card-header py-3">
                  <h5 className="mb-0 fw-semibold">
                    <i className="ph ph-gauge card-icon" />
                    Pending Vehicle Readings
                  </h5>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                    <table className="table align-middle mb-0">
                      <thead className="sticky-thead">
                        <tr>
                          <th>Sr.No</th>
                          <th>Date</th>
                          <th>Project Category</th>
                          <th>Project</th>
                          <th>Vehicle Type</th>
                          <th>Vehicle No</th>
                          <th>Start Reading</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingVehicleReading.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center text-muted py-4">
                              No pending Vehicle Readings found
                            </td>
                          </tr>
                        ) : (
                          pendingVehicleReading.map((item, idx) => (
                            <tr key={item.id}>
                              <td>{idx + 1}</td>
                              <td>{formatDate(item.readingDate)}</td>
                              <td>{item.projectCategoryName || "-"}</td>
                              <td>{item.projectName || "-"}</td>
                              <td>{item.vehicleType || "-"}</td>
                              <td className="fw-semibold">{item.registrationNo || "-"}</td>
                              <td>
                                {item.readingType?.toLowerCase() === "custom"
                                  ? (item.startTime ? formatDateTime(item.startTime) : "-")
                                  : (item.startReading !== null && item.startReading !== undefined ? item.startReading : "-")
                                }
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* PENDING AT DPR (STOCK OUT) */}
            <div className="col-12">
              <div className="card h-100 corp-card-premium" style={{ "--card-accent": "#3b82f6", "--card-accent-bg": "#dbeafe" }}>
                <div className="card-header py-3">
                  <h5 className="mb-0 fw-semibold">
                    <i className="ph ph-arrow-square-out card-icon" />
                    Pending at DPR (From Stock Out)
                  </h5>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive table-scroll" style={{ maxHeight: "300px" }}>
                    <table className="table align-middle mb-0">
                      <thead className="sticky-thead">
                        <tr>
                          <th>Sr.No</th>
                          <th>Date</th>
                          <th>Project Category</th>
                          <th>Project</th>
                          <th>To Location</th>
                          <th>Voucher No</th>
                          <th>Item Category</th>
                          <th>Item</th>
                          <th className="text-end">Issued Qty</th>
                          <th className="text-end">Pending Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {pendingDPRStockOut.length === 0 ? (
                          <tr>
                            <td colSpan="10" className="text-center text-muted py-4">
                              No records found pending at DPR (Stock Out)
                            </td>
                          </tr>
                        ) : (
                          pendingDPRStockOut.map((item, idx) => (
                            <tr key={idx}>
                              <td>{idx + 1}</td>
                              <td>{formatDate(item.date)}</td>
                              <td>{item.projectCategory || "-"}</td>
                              <td>{item.project || "-"}</td>
                              <td>{item.toLocation || "-"}</td>
                              <td className="fw-semibold">{item.voucherNo || "-"}</td>
                              <td>{item.itemCategory || "-"}</td>
                              <td>{item.item || "-"}</td>
                              <td className="text-end fw-semibold text-dark">
                                {Number(item.issuedQty || 0).toLocaleString(undefined, { minimumFractionDigits: 3 })}
                              </td>
                              <td className="text-end fw-semibold text-danger">
                                {Number(item.pendingQty || 0).toLocaleString(undefined, { minimumFractionDigits: 3 })}
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabPanel>


      </Tabs>








      {/* VEHICLE DUES DETAILS MODAL */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes scaleIn {
          from { transform: scale(0.95); opacity: 0; }
          to { transform: scale(1); opacity: 1; }
        }
      `}</style>

      {duesModal.isOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          animation: 'fadeIn 0.2s ease-out'
        }}>
          <div className="card corp-card-premium" style={{
            width: '100%',
            maxWidth: '750px',
            borderRadius: '16px',
            backgroundColor: '#ffffff',
            border: '1px solid rgba(226, 232, 240, 0.8)',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            transform: 'scale(1)',
            animation: 'scaleIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
            overflow: 'hidden'
          }}>
            <div className="card-header d-flex justify-content-between align-items-center py-3 px-4" style={{
              backgroundColor: '#f8fafc',
              borderBottom: '1px solid #f1f5f9'
            }}>
              <h5 className="mb-0 fw-semibold text-slate-800 d-flex align-items-center gap-2">
                <i className={`ph ${duesModal.type === 'Service' ? 'ph-wrench text-sky-500' : duesModal.type === 'Tax' ? 'ph-percent text-emerald-500' : 'ph-shield-check text-amber-500'}`} style={{ fontSize: '1.25rem' }} />
                Pending {duesModal.type} Vehicles
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseDuesModal}
                style={{ cursor: 'pointer', boxShadow: 'none' }}
              />
            </div>

            <div className="card-body p-4" style={{ maxHeight: '450px', overflowY: 'auto' }}>
              {duesModal.list.length === 0 ? (
                <div className="text-center py-5 text-muted">
                  <i className="ph ph-check-circle" style={{ fontSize: '3rem', color: '#10b981', display: 'block', marginBottom: '1rem' }} />
                  No vehicles with pending {duesModal.type.toLowerCase()} found.
                </div>
              ) : (
                <div className="table-responsive">
                  <table className="table align-middle table-hover mb-0">
                    <thead style={{ backgroundColor: '#f8fafc' }}>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Registration No</th>
                        <th>Vehicle Type</th>
                        <th>Project</th>
                        <th>Project Category</th>
                        <th>Due Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {duesModal.list.map((vehicle, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>
                            <span className="badge bg-light text-dark border px-2.5 py-1.5 fw-mono" style={{ fontSize: '0.85rem' }}>
                              {vehicle.registrationNo}
                            </span>
                          </td>
                          <td className="fw-semibold text-slate-800">{vehicle.vehicleType}</td>
                          <td>{vehicle.projectName || 'Unassigned'}</td>
                          <td>{vehicle.projectCategoryName || 'N/A'}</td>
                          <td className="text-danger fw-medium">{formatDate(vehicle.nextDate)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            <div className="card-footer py-3 px-4 d-flex justify-content-end" style={{
              backgroundColor: '#f8fafc',
              borderTop: '1px solid #f1f5f9'
            }}>
              <button
                type="button"
                className="btn btn-secondary px-4"
                onClick={handleCloseDuesModal}
                style={{ borderRadius: '8px' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {dprDetailsModal.isOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          animation: 'fadeIn 0.2s ease-out'
        }}>
          <div className="card corp-card-premium" style={{
            width: '95%',
            maxWidth: '1200px',
            borderRadius: '16px',
            backgroundColor: '#ffffff',
            border: '1px solid rgba(226, 232, 240, 0.8)',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            transform: 'scale(1)',
            animation: 'scaleIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
            overflow: 'hidden'
          }}>
            <div className="card-header d-flex justify-content-between align-items-center py-3 px-4" style={{
              backgroundColor: '#f8fafc',
              borderBottom: '1px solid #f1f5f9'
            }}>
              <h5 className="mb-0 fw-semibold text-slate-800 d-flex align-items-center gap-2">
                <i className="ph ph-calendar-blank text-primary" style={{ fontSize: '1.25rem' }} />
                DPR Details: {dprDetailsModal.data?.projectName || 'Loading...'} {dprDetailsModal.data?.reportDate ? `(${formatDisplayDate(dprDetailsModal.data.reportDate.split('T')[0])})` : ''}
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={handleCloseDPRModal}
                style={{ cursor: 'pointer', boxShadow: 'none' }}
              />
            </div>

            <div className="card-body p-4" style={{ maxHeight: '600px', overflowY: 'auto' }}>
              {dprDetailsModal.loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-primary" role="status" />
                  <p className="mt-3 text-muted">Loading DPR details...</p>
                </div>
              ) : !dprDetailsModal.data ? (
                <div className="text-center py-5 text-muted">
                  No details found for this record.
                </div>
              ) : (
                <>
                  {dprDetailsModal.data.workStatus === "IDLE" ? (
                    <div className="p-3 bg-light rounded border">
                      <h6 className="fw-bold text-warning mb-2">Idle Note</h6>
                      <p className="mb-0">{dprDetailsModal.data.idleNote || "No idle notes specified."}</p>
                    </div>
                  ) : (
                    <>
                      <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                          <button
                            type="button"
                            className={`nav-link ${dprDetailsModal.activeTab === "work" ? "active" : ""}`}
                            onClick={() => setDprDetailsModal(prev => ({ ...prev, activeTab: "work" }))}
                            style={{ cursor: 'pointer' }}
                          >
                            Work Progress
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            type="button"
                            className={`nav-link ${dprDetailsModal.activeTab === "material" ? "active" : ""}`}
                            onClick={() => setDprDetailsModal(prev => ({ ...prev, activeTab: "material" }))}
                            style={{ cursor: 'pointer' }}
                          >
                            Material Consumption
                          </button>
                        </li>
                        <li className="nav-item">
                          <button
                            type="button"
                            className={`nav-link ${dprDetailsModal.activeTab === "labour" ? "active" : ""}`}
                            onClick={() => setDprDetailsModal(prev => ({ ...prev, activeTab: "labour" }))}
                            style={{ cursor: 'pointer' }}
                          >
                            Working Labour
                          </button>
                        </li>
                      </ul>

                      {/* WORK PROGRESS PANEL */}
                      {dprDetailsModal.activeTab === "work" && (
                        <div className="table-responsive">
                          <table className="table table-bordered table-striped align-middle">
                            <thead className="table-light">
                              <tr>
                                {dprDetailsModal.data.projectCategoryName === "Civil Works" ? (
                                  <th>Location</th>
                                ) : (
                                  <>
                                    <th>From Ch</th>
                                    <th>To Ch</th>
                                  </>
                                )}
                                <th>Work Item</th>
                                <th>Side</th>
                                <th>Work Activity</th>
                                <th>UOM</th>
                                {dprDetailsModal.data.projectCategoryName === "Civil Works" && (
                                  <>
                                    <th>Length</th>
                                    <th>Breadth</th>
                                    <th>Depth</th>
                                  </>
                                )}
                                <th>Project Qty</th>
                                <th>Work Qty</th>
                                <th>Description</th>
                                <th>Remarks</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(!dprDetailsModal.data.items || dprDetailsModal.data.items.length === 0) ? (
                                <tr>
                                  <td colSpan={dprDetailsModal.data.projectCategoryName === "Civil Works" ? 11 : 10} className="text-center text-muted py-3">
                                    No work progress entries recorded
                                  </td>
                                </tr>
                              ) : (
                                dprDetailsModal.data.items.map((i, idx) => (
                                  <tr key={i.id || idx}>
                                    {dprDetailsModal.data.projectCategoryName === "Civil Works" ? (
                                      <td>{i.locationName || "-"}</td>
                                    ) : (
                                      <>
                                        <td>{i.fromChainage || "-"}</td>
                                        <td>{i.toChainage || "-"}</td>
                                      </>
                                    )}
                                    <td className="fw-semibold">{i.workItemCode}</td>
                                    <td>{i.side}</td>
                                    <td>{i.workActivity || "-"}</td>
                                    <td>{i.UOM}</td>
                                    {dprDetailsModal.data.projectCategoryName === "Civil Works" && (
                                      <>
                                        <td>{i.length ?? "-"}</td>
                                        <td>{i.breadth ?? "-"}</td>
                                        <td>{i.depth ?? "-"}</td>
                                      </>
                                    )}
                                    <td>{i.projectQuantity}</td>
                                    <td>{i.workQuantity}</td>
                                    <td>{i.description || "-"}</td>
                                    <td>{i.remarks || "-"}</td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/* MATERIAL CONSUMPTION PANEL */}
                      {dprDetailsModal.activeTab === "material" && (
                        <div className="table-responsive">
                          <table className="table table-bordered table-striped align-middle">
                            <thead className="table-light">
                              <tr>
                                <th>Voucher</th>
                                <th>Item Category</th>
                                <th>Item Name</th>
                                <th className="text-end">Issued</th>
                                <th className="text-end">Used</th>
                                <th className="text-end">Lost</th>
                                <th className="text-end">Damaged</th>
                                <th className="text-end">Returned</th>
                                <th className="text-end">Site Balance</th>
                                <th>Notes</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(!dprDetailsModal.data.materialItems || dprDetailsModal.data.materialItems.length === 0) ? (
                                <tr>
                                  <td colSpan="10" className="text-center text-muted py-3">
                                    No material consumption entries recorded
                                  </td>
                                </tr>
                              ) : (
                                dprDetailsModal.data.materialItems.map((m, idx) => (
                                  <tr key={idx}>
                                    <td>{m.stockOutVoucherNo}</td>
                                    <td>{m.itemCategoryName || m.itemCategory || "-"}</td>
                                    <td className="fw-semibold">{m.itemCode || m.itemName || "-"}</td>
                                    <td className="text-end text-success-emphasis fw-medium">{Number(m.issuedQty || 0).toFixed(3)}</td>
                                    <td className="text-end">{Number(m.quantityUsed || 0).toFixed(3)}</td>
                                    <td className="text-end">{Number(m.quantityLost || 0).toFixed(3)}</td>
                                    <td className="text-end">{Number(m.quantityDamaged || 0).toFixed(3)}</td>
                                    <td className="text-end">{Number(m.quantityReturned || 0).toFixed(3)}</td>
                                    <td className="text-end fw-semibold text-primary">{Number(m.siteBalance || 0).toFixed(3)}</td>
                                    <td>{m.notes || "-"}</td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}

                      {/* WORKING LABOUR PANEL */}
                      {dprDetailsModal.activeTab === "labour" && (
                        <div className="table-responsive">
                          <table className="table table-bordered table-striped align-middle">
                            <thead className="table-light">
                              <tr>
                                <th>Vendor</th>
                                <th>Skilled Labour</th>
                                <th>Unskilled Labour</th>
                                <th>Notes</th>
                              </tr>
                            </thead>
                            <tbody>
                              {(!dprDetailsModal.data.labourItems || dprDetailsModal.data.labourItems.length === 0) ? (
                                <tr>
                                  <td colSpan="4" className="text-center text-muted py-3">
                                    No labour entries recorded
                                  </td>
                                </tr>
                              ) : (
                                dprDetailsModal.data.labourItems.map((l, idx) => (
                                  <tr key={idx}>
                                    <td className="fw-semibold">{l.vendorName}</td>
                                    <td>{l.skilledLabour}</td>
                                    <td>{l.unSkilledLabour}</td>
                                    <td>{l.notes || "-"}</td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>

            <div className="card-footer py-3 px-4 d-flex justify-content-end" style={{
              backgroundColor: '#f8fafc',
              borderTop: '1px solid #f1f5f9'
            }}>
              <button
                type="button"
                className="btn btn-secondary px-4"
                onClick={handleCloseDPRModal}
                style={{ borderRadius: '8px' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {vehicleDetailsModal.isOpen && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(15, 23, 42, 0.45)',
          backdropFilter: 'blur(8px)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
          animation: 'fadeIn 0.2s ease-out'
        }}>
          <div className="card corp-card-premium" style={{
            width: '100%',
            maxWidth: '1100px',
            borderRadius: '16px',
            backgroundColor: '#ffffff',
            border: '1px solid rgba(226, 232, 240, 0.8)',
            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
            transform: 'scale(1)',
            animation: 'scaleIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)',
            overflow: 'hidden'
          }}>
            <div className="card-header d-flex justify-content-between align-items-center py-3 px-4" style={{
              backgroundColor: '#f8fafc',
              borderBottom: '1px solid #f1f5f9'
            }}>
              <h5 className="mb-0 fw-semibold text-slate-800 d-flex align-items-center gap-2">
                <i className="ph ph-truck text-primary" style={{ fontSize: '1.25rem' }} />
                {vehicleDetailsModal.vehicleType}: {vehicleDetailsModal.statusType} Vehicles
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setVehicleDetailsModal(prev => ({ ...prev, isOpen: false }))}
                style={{ cursor: 'pointer', boxShadow: 'none' }}
              />
            </div>

            <div className="card-body p-4" style={{ maxHeight: '450px', overflowY: 'auto' }}>
              <div className="table-responsive">
                <table className="table align-middle table-hover mb-0">
                  <thead style={{ backgroundColor: '#f8fafc' }}>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Registration No</th>
                      <th>Owner Name</th>
                      <th>Fuel Burn By</th>
                      <th>Readings</th>
                      <th>Total Reading</th>
                      <th>Fuel Type</th>
                      <th>Fuel Qty</th>
                      <th>Per Qty (Rate)</th>
                      <th>Total Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vehicleDetailsModal.list.map((vehicle, idx) => {
                      const isObject = typeof vehicle === 'object' && vehicle !== null;
                      const regNo = isObject ? vehicle.registrationNo : vehicle;
                      const isLease = isObject && (vehicle.ownerShipType || "").toLowerCase() === "lease";
                      const vendorName = isObject ? (vehicle.vendorName || "").trim() : "";
                      const vehicleName = isObject ? (vehicle.vehicleName || "").trim() : "";

                      const renderOwnerName = () => {
                        if (!isObject) return "-";
                        if (isLease) {
                          if (vendorName && vehicleName) {
                            return (
                              <div>
                                <div className="fw-medium">{vendorName}</div>
                                <div className="text-muted small">({vehicleName})</div>
                              </div>
                            );
                          } else if (vendorName) {
                            return <div className="fw-medium">{vendorName}</div>;
                          } else if (vehicleName) {
                            return <div className="text-muted small">({vehicleName})</div>;
                          }
                          return "-";
                        }
                        return vehicleName || vehicle.vehicleOwnerName || vehicle.ownerName || "-";
                      };

                      const fuelBurnBy = isObject
                        ? (vehicle.fuelBurnBy || vehicle.fuelburnby || vehicle.fuelBorneBy || "-")
                        : "-";
                      const fromReading = isObject ? vehicle.fromReading : null;
                      const toReading = isObject ? vehicle.toReading : null;
                      const totalReading = isObject ? vehicle.totalReading : null;
                      const fuelType = isObject ? vehicle.fuelType : null;
                      const fuelQty = isObject ? vehicle.fuelQuantityLiters : null;
                      const fuelAmount = isObject ? vehicle.fuelAmount : null;

                      const perQty = (fuelQty > 0 && fuelAmount > 0)
                        ? (Number(fuelAmount) / Number(fuelQty)).toFixed(2)
                        : null;

                      return (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>
                            <span className="badge bg-light text-dark border px-2.5 py-1.5 fw-mono" style={{ fontSize: '0.85rem' }}>
                              {regNo}
                            </span>
                          </td>
                          <td>{renderOwnerName()}</td>
                          <td>{fuelBurnBy}</td>
                          <td>
                            {(() => {
                              const list = (isObject && vehicle.readingsList)
                                ? vehicle.readingsList.filter(r => r && r.id !== null)
                                : [];
                              if (list.length === 0) {
                                return <span className="text-muted">-</span>;
                              }
                              // Sort list by id to ensure chronological order
                              list.sort((a, b) => a.id - b.id);

                              return (
                                <div className="d-flex flex-column gap-1">
                                  {list.map((r, rIdx) => {
                                    if (r.workingStatus && r.workingStatus.toLowerCase() !== "working") {
                                      return (
                                        <div key={r.id || rIdx} className="text-muted fst-italic">
                                          {r.workingStatus}
                                        </div>
                                      );
                                    }
                                    const isCustom = r.startTime || r.endTime;
                                    if (isCustom) {
                                      const formatTimeOnly = (tStr) => {
                                        if (!tStr) return "-";
                                        try {
                                          const d = new Date(tStr);
                                          if (isNaN(d.getTime())) return tStr;
                                          let hours = d.getHours();
                                          const minutes = String(d.getMinutes()).padStart(2, '0');
                                          const ampm = hours >= 12 ? 'PM' : 'AM';
                                          hours = hours % 12;
                                          hours = hours ? hours : 12;
                                          return `${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
                                        } catch {
                                          return tStr;
                                        }
                                      };
                                      return (
                                        <div key={r.id || rIdx}>
                                          {formatTimeOnly(r.startTime)} to {formatTimeOnly(r.endTime)}
                                        </div>
                                      );
                                    }
                                    return (
                                      <div key={r.id || rIdx}>
                                        {r.fromReading !== null ? r.fromReading : '-'} to {r.toReading !== null ? r.toReading : '-'}
                                      </div>
                                    );
                                  })}
                                </div>
                              );
                            })()}
                          </td>
                          <td>
                            {totalReading !== null && Number(totalReading) > 0 ? (
                              <span className="fw-semibold">{Number(totalReading).toFixed(2)}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>{fuelType || <span className="text-muted">-</span>}</td>
                          <td>
                            {fuelQty !== null && Number(fuelQty) > 0 ? (
                              <span>{Number(fuelQty).toLocaleString()} L</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {perQty !== null ? (
                              <span>₹ {Number(perQty).toLocaleString()}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            {fuelAmount !== null && Number(fuelAmount) > 0 ? (
                              <span className="fw-bold text-success">₹ {Number(fuelAmount).toLocaleString()}</span>
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="card-footer py-3 px-4 d-flex justify-content-end" style={{
              backgroundColor: '#f8fafc',
              borderTop: '1px solid #f1f5f9'
            }}>
              <button
                type="button"
                className="btn btn-secondary px-4"
                onClick={() => setVehicleDetailsModal(prev => ({ ...prev, isOpen: false }))}
                style={{ borderRadius: '8px' }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
